//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class Client {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ? baseUrl : "";

    }

    /**
     * Get all invoice batches in the system, filtered by status and open date
     * @param openedAfter (optional) 
     * @param includeDeleted (optional) 
     * @param includeClosedAndExportedBatches (optional) 
     * @return OK
     */
    getInvoiceBatches(openedAfter?: Date | undefined, includeDeleted?: boolean | undefined, includeClosedAndExportedBatches?: boolean | undefined, cancelToken?: CancelToken): Promise<InvoiceBatchModel[]> {
        let url_ = this.baseUrl + "/api/v1/accounting/invoicebatches?";
        if (openedAfter === null)
            throw new globalThis.Error("The parameter 'openedAfter' cannot be null.");
        else if (openedAfter !== undefined)
            url_ += "openedAfter=" + encodeURIComponent(openedAfter ? "" + openedAfter.toISOString() : "") + "&";
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        if (includeClosedAndExportedBatches === null)
            throw new globalThis.Error("The parameter 'includeClosedAndExportedBatches' cannot be null.");
        else if (includeClosedAndExportedBatches !== undefined)
            url_ += "includeClosedAndExportedBatches=" + encodeURIComponent("" + includeClosedAndExportedBatches) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceBatches(_response);
        });
    }

    protected processGetInvoiceBatches(response: AxiosResponse): Promise<InvoiceBatchModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceBatchModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<InvoiceBatchModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceBatchModel[]>(null as any);
    }

    /**
     * Get the specified invoice batch
     * @return OK
     */
    getInvoiceBatch(batchgid: string, cancelToken?: CancelToken): Promise<InvoiceBatchModel> {
        let url_ = this.baseUrl + "/api/v1/accounting/invoicebatches/{batchgid}";
        if (batchgid === undefined || batchgid === null)
            throw new globalThis.Error("The parameter 'batchgid' must be defined.");
        url_ = url_.replace("{batchgid}", encodeURIComponent("" + batchgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceBatch(_response);
        });
    }

    protected processGetInvoiceBatch(response: AxiosResponse): Promise<InvoiceBatchModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceBatchModel.fromJS(resultData200);
            return Promise.resolve<InvoiceBatchModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceBatchModel>(null as any);
    }

    /**
     * Updates the specified invoice batch
     * @param body (optional) 
     * @return OK
     */
    updateInvoiceBatch(batchgid: string, body?: UpdateInvoiceBatchRequestModel | undefined, cancelToken?: CancelToken): Promise<InvoiceBatchModel> {
        let url_ = this.baseUrl + "/api/v1/accounting/invoicebatches/{batchgid}";
        if (batchgid === undefined || batchgid === null)
            throw new globalThis.Error("The parameter 'batchgid' must be defined.");
        url_ = url_.replace("{batchgid}", encodeURIComponent("" + batchgid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInvoiceBatch(_response);
        });
    }

    protected processUpdateInvoiceBatch(response: AxiosResponse): Promise<InvoiceBatchModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceBatchModel.fromJS(resultData200);
            return Promise.resolve<InvoiceBatchModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceBatchModel>(null as any);
    }

    /**
     * Creates a new invoice batch
     * @param body (optional) 
     * @return OK
     */
    createInvoiceBatch(body?: CreateInvoiceBatchRequestModel | undefined, cancelToken?: CancelToken): Promise<InvoiceBatchModel> {
        let url_ = this.baseUrl + "/api/v1/accounting/invoicebatches/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateInvoiceBatch(_response);
        });
    }

    protected processCreateInvoiceBatch(response: AxiosResponse): Promise<InvoiceBatchModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceBatchModel.fromJS(resultData200);
            return Promise.resolve<InvoiceBatchModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceBatchModel>(null as any);
    }

    /**
     * Get all invoices associated to a specific batch
     * @return OK
     */
    getBatchInvoices(batchgid: string, cancelToken?: CancelToken): Promise<InvoiceModel[]> {
        let url_ = this.baseUrl + "/api/v1/accounting/invoicebatches/{batchgid}/invoices";
        if (batchgid === undefined || batchgid === null)
            throw new globalThis.Error("The parameter 'batchgid' must be defined.");
        url_ = url_.replace("{batchgid}", encodeURIComponent("" + batchgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBatchInvoices(_response);
        });
    }

    protected processGetBatchInvoices(response: AxiosResponse): Promise<InvoiceModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<InvoiceModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceModel[]>(null as any);
    }

    /**
     * Get invoice batch MYOB files
     * @return OK
     */
    exportBatch(batchgid: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/accounting/invoicebatches/{batchgid}/export";
        if (batchgid === undefined || batchgid === null)
            throw new globalThis.Error("The parameter 'batchgid' must be defined.");
        url_ = url_.replace("{batchgid}", encodeURIComponent("" + batchgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportBatch(_response);
        });
    }

    protected processExportBatch(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get the specified invoice
     * @return OK
     */
    getInvoice(invoicegid: string, cancelToken?: CancelToken): Promise<InvoiceModel> {
        let url_ = this.baseUrl + "/api/v1/accounting/invoices/{invoicegid}";
        if (invoicegid === undefined || invoicegid === null)
            throw new globalThis.Error("The parameter 'invoicegid' must be defined.");
        url_ = url_.replace("{invoicegid}", encodeURIComponent("" + invoicegid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoice(_response);
        });
    }

    protected processGetInvoice(response: AxiosResponse): Promise<InvoiceModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceModel.fromJS(resultData200);
            return Promise.resolve<InvoiceModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceModel>(null as any);
    }

    /**
     * Updates the invoice
     * @param body (optional) 
     * @return OK
     */
    updateInvoice(invoicegid: string, body?: UpdateInvoiceRequestModel | undefined, cancelToken?: CancelToken): Promise<InvoiceModel> {
        let url_ = this.baseUrl + "/api/v1/accounting/invoices/{invoicegid}";
        if (invoicegid === undefined || invoicegid === null)
            throw new globalThis.Error("The parameter 'invoicegid' must be defined.");
        url_ = url_.replace("{invoicegid}", encodeURIComponent("" + invoicegid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInvoice(_response);
        });
    }

    protected processUpdateInvoice(response: AxiosResponse): Promise<InvoiceModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceModel.fromJS(resultData200);
            return Promise.resolve<InvoiceModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceModel>(null as any);
    }

    /**
     * Create a new invoice and associated line items
     * @param body (optional) 
     * @return OK
     */
    createInvoice(body?: CreateInvoiceRequestModel | undefined, cancelToken?: CancelToken): Promise<InvoiceModel> {
        let url_ = this.baseUrl + "/api/v1/accounting/invoices/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateInvoice(_response);
        });
    }

    protected processCreateInvoice(response: AxiosResponse): Promise<InvoiceModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceModel.fromJS(resultData200);
            return Promise.resolve<InvoiceModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceModel>(null as any);
    }

    /**
     * Creates a new client
     * @param body (optional) 
     * @return OK
     */
    createClient(body?: ClientCreateModel | undefined, cancelToken?: CancelToken): Promise<ClientModel> {
        let url_ = this.baseUrl + "/api/v1/client/clients/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateClient(_response);
        });
    }

    protected processCreateClient(response: AxiosResponse): Promise<ClientModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientModel.fromJS(resultData200);
            return Promise.resolve<ClientModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientModel>(null as any);
    }

    /**
     * Gets a client from the client gid
     * @return OK
     */
    getClient(clientgid: string, cancelToken?: CancelToken): Promise<ClientModel> {
        let url_ = this.baseUrl + "/api/v1/client/clients/{clientgid}";
        if (clientgid === undefined || clientgid === null)
            throw new globalThis.Error("The parameter 'clientgid' must be defined.");
        url_ = url_.replace("{clientgid}", encodeURIComponent("" + clientgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClient(_response);
        });
    }

    protected processGetClient(response: AxiosResponse): Promise<ClientModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientModel.fromJS(resultData200);
            return Promise.resolve<ClientModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientModel>(null as any);
    }

    /**
     * Updates a client
     * @param body (optional) 
     * @return OK
     */
    updateClient(clientgid: string, body?: ClientUpdateModel | undefined, cancelToken?: CancelToken): Promise<ClientModel> {
        let url_ = this.baseUrl + "/api/v1/client/clients/{clientgid}";
        if (clientgid === undefined || clientgid === null)
            throw new globalThis.Error("The parameter 'clientgid' must be defined.");
        url_ = url_.replace("{clientgid}", encodeURIComponent("" + clientgid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateClient(_response);
        });
    }

    protected processUpdateClient(response: AxiosResponse): Promise<ClientModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientModel.fromJS(resultData200);
            return Promise.resolve<ClientModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientModel>(null as any);
    }

    /**
     * Delete the specified client
     * @return OK
     */
    deleteClient(clientgid: string, cancelToken?: CancelToken): Promise<ClientModel> {
        let url_ = this.baseUrl + "/api/v1/client/clients/{clientgid}";
        if (clientgid === undefined || clientgid === null)
            throw new globalThis.Error("The parameter 'clientgid' must be defined.");
        url_ = url_.replace("{clientgid}", encodeURIComponent("" + clientgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteClient(_response);
        });
    }

    protected processDeleteClient(response: AxiosResponse): Promise<ClientModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ClientModel.fromJS(resultData200);
            return Promise.resolve<ClientModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientModel>(null as any);
    }

    /**
     * Creates a new contact
     * @param clientgid The gid of the parent client
     * @param body (optional) The contact data model
     * @return OK
     */
    createContact(clientgid: string, body?: ContactCreateModel | undefined, cancelToken?: CancelToken): Promise<ContactModel> {
        let url_ = this.baseUrl + "/api/v1/client/clients/{clientgid}/contacts/create";
        if (clientgid === undefined || clientgid === null)
            throw new globalThis.Error("The parameter 'clientgid' must be defined.");
        url_ = url_.replace("{clientgid}", encodeURIComponent("" + clientgid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateContact(_response);
        });
    }

    protected processCreateContact(response: AxiosResponse): Promise<ContactModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContactModel.fromJS(resultData200);
            return Promise.resolve<ContactModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactModel>(null as any);
    }

    /**
     * Updates a contact
     * @param clientgid The gid of the parent client
     * @param contactgid The gid of the contact to update
     * @param body (optional) The update contact model
     * @return OK
     */
    updateContact(clientgid: string, contactgid: string, body?: ContactUpdateModel | undefined, cancelToken?: CancelToken): Promise<ContactModel> {
        let url_ = this.baseUrl + "/api/v1/client/clients/{clientgid}/contacts/{contactgid}";
        if (clientgid === undefined || clientgid === null)
            throw new globalThis.Error("The parameter 'clientgid' must be defined.");
        url_ = url_.replace("{clientgid}", encodeURIComponent("" + clientgid));
        if (contactgid === undefined || contactgid === null)
            throw new globalThis.Error("The parameter 'contactgid' must be defined.");
        url_ = url_.replace("{contactgid}", encodeURIComponent("" + contactgid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateContact(_response);
        });
    }

    protected processUpdateContact(response: AxiosResponse): Promise<ContactModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContactModel.fromJS(resultData200);
            return Promise.resolve<ContactModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactModel>(null as any);
    }

    /**
     * Delete the specified contact
     * @return OK
     */
    deleteContact(clientgid: string, contactgid: string, cancelToken?: CancelToken): Promise<ContactModel> {
        let url_ = this.baseUrl + "/api/v1/client/clients/{clientgid}/contacts/{contactgid}";
        if (clientgid === undefined || clientgid === null)
            throw new globalThis.Error("The parameter 'clientgid' must be defined.");
        url_ = url_.replace("{clientgid}", encodeURIComponent("" + clientgid));
        if (contactgid === undefined || contactgid === null)
            throw new globalThis.Error("The parameter 'contactgid' must be defined.");
        url_ = url_.replace("{contactgid}", encodeURIComponent("" + contactgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteContact(_response);
        });
    }

    protected processDeleteContact(response: AxiosResponse): Promise<ContactModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContactModel.fromJS(resultData200);
            return Promise.resolve<ContactModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactModel>(null as any);
    }

    /**
     * Searches for any matching clients
     * @param searchCriteria (optional) 
     * @return OK
     */
    searchClients(searchCriteria?: string | undefined, cancelToken?: CancelToken): Promise<ClientSearchResultModel[]> {
        let url_ = this.baseUrl + "/api/v1/client/clients/search?";
        if (searchCriteria === null)
            throw new globalThis.Error("The parameter 'searchCriteria' cannot be null.");
        else if (searchCriteria !== undefined)
            url_ += "searchCriteria=" + encodeURIComponent("" + searchCriteria) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchClients(_response);
        });
    }

    protected processSearchClients(response: AxiosResponse): Promise<ClientSearchResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ClientSearchResultModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ClientSearchResultModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ClientSearchResultModel[]>(null as any);
    }

    /**
     * Get all invoices associated with this client
     * @return OK
     */
    getClientInvoices(clientgid: string, cancelToken?: CancelToken): Promise<InvoiceModel[]> {
        let url_ = this.baseUrl + "/api/v1/client/clients/{clientgid}/invoices";
        if (clientgid === undefined || clientgid === null)
            throw new globalThis.Error("The parameter 'clientgid' must be defined.");
        url_ = url_.replace("{clientgid}", encodeURIComponent("" + clientgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetClientInvoices(_response);
        });
    }

    protected processGetClientInvoices(response: AxiosResponse): Promise<InvoiceModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<InvoiceModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceModel[]>(null as any);
    }

    /**
     * Returns the list of employees that can be assigned to a job type
     * @param jobItemType (optional) The job type that the employee is capable of
     * @return OK
     */
    getAssignableEmployees(jobItemType?: JobItemType | undefined, cancelToken?: CancelToken): Promise<EmployeeModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/employees/assignable?";
        if (jobItemType === null)
            throw new globalThis.Error("The parameter 'jobItemType' cannot be null.");
        else if (jobItemType !== undefined)
            url_ += "jobItemType=" + encodeURIComponent("" + jobItemType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssignableEmployees(_response);
        });
    }

    protected processGetAssignableEmployees(response: AxiosResponse): Promise<EmployeeModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EmployeeModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeModel[]>(null as any);
    }

    /**
     * Returns the list of employees
     * @return OK
     */
    getEmployees( cancelToken?: CancelToken): Promise<EmployeeModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/employees";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployees(_response);
        });
    }

    protected processGetEmployees(response: AxiosResponse): Promise<EmployeeModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<EmployeeModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeModel[]>(null as any);
    }

    /**
     * Creates a new employee
     * @param body (optional) 
     * @return OK
     */
    createEmployee(body?: EmployeeCreateModel | undefined, cancelToken?: CancelToken): Promise<EmployeeModel> {
        let url_ = this.baseUrl + "/api/v1/core/employees/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEmployee(_response);
        });
    }

    protected processCreateEmployee(response: AxiosResponse): Promise<EmployeeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployeeModel.fromJS(resultData200);
            return Promise.resolve<EmployeeModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeModel>(null as any);
    }

    /**
     * Gets a employee from the employee gid
     * @return OK
     */
    getEmployee(employeegid: string, cancelToken?: CancelToken): Promise<EmployeeModel> {
        let url_ = this.baseUrl + "/api/v1/core/employees/{employeegid}";
        if (employeegid === undefined || employeegid === null)
            throw new globalThis.Error("The parameter 'employeegid' must be defined.");
        url_ = url_.replace("{employeegid}", encodeURIComponent("" + employeegid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployee(_response);
        });
    }

    protected processGetEmployee(response: AxiosResponse): Promise<EmployeeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployeeModel.fromJS(resultData200);
            return Promise.resolve<EmployeeModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeModel>(null as any);
    }

    /**
     * Updates a employee
     * @param body (optional) 
     * @return OK
     */
    updateEmployee(employeegid: string, body?: EmployeeUpdateModel | undefined, cancelToken?: CancelToken): Promise<EmployeeModel> {
        let url_ = this.baseUrl + "/api/v1/core/employees/{employeegid}";
        if (employeegid === undefined || employeegid === null)
            throw new globalThis.Error("The parameter 'employeegid' must be defined.");
        url_ = url_.replace("{employeegid}", encodeURIComponent("" + employeegid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateEmployee(_response);
        });
    }

    protected processUpdateEmployee(response: AxiosResponse): Promise<EmployeeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployeeModel.fromJS(resultData200);
            return Promise.resolve<EmployeeModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeModel>(null as any);
    }

    /**
     * Delete the specified employee
     * @return OK
     */
    deleteEmployee(employeegid: string, cancelToken?: CancelToken): Promise<EmployeeModel> {
        let url_ = this.baseUrl + "/api/v1/core/employees/{employeegid}";
        if (employeegid === undefined || employeegid === null)
            throw new globalThis.Error("The parameter 'employeegid' must be defined.");
        url_ = url_.replace("{employeegid}", encodeURIComponent("" + employeegid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEmployee(_response);
        });
    }

    protected processDeleteEmployee(response: AxiosResponse): Promise<EmployeeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployeeModel.fromJS(resultData200);
            return Promise.resolve<EmployeeModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeModel>(null as any);
    }

    /**
     * Creates a new document and stores the file
     * @param name (optional) 
     * @param type (optional) 
     * @param folderName (optional) 
     * @param jobGid (optional) 
     * @param file (optional) 
     * @return OK
     */
    uploadDocument(name?: string | undefined, type?: DocumentType | undefined, folderName?: string | undefined, jobGid?: string | undefined, file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<DocumentModel> {
        let url_ = this.baseUrl + "/api/v1/file/documents/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name === null || name === undefined)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else
            content_.append("name", name.toString());
        if (type === null || type === undefined)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else
            content_.append("type", type.toString());
        if (folderName === null || folderName === undefined)
            throw new globalThis.Error("The parameter 'folderName' cannot be null.");
        else
            content_.append("folderName", folderName.toString());
        if (jobGid === null || jobGid === undefined)
            throw new globalThis.Error("The parameter 'jobGid' cannot be null.");
        else
            content_.append("jobGid", jobGid.toString());
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadDocument(_response);
        });
    }

    protected processUploadDocument(response: AxiosResponse): Promise<DocumentModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DocumentModel.fromJS(resultData200);
            return Promise.resolve<DocumentModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentModel>(null as any);
    }

    /**
     * Get document details
     * @param jobgid (optional) 
     * @return OK
     */
    getDocument(documentgid: string, jobgid?: string | undefined, cancelToken?: CancelToken): Promise<DocumentModel[]> {
        let url_ = this.baseUrl + "/api/v1/file/documents/{documentgid}?";
        if (documentgid === undefined || documentgid === null)
            throw new globalThis.Error("The parameter 'documentgid' must be defined.");
        url_ = url_.replace("{documentgid}", encodeURIComponent("" + documentgid));
        if (jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' cannot be null.");
        else if (jobgid !== undefined)
            url_ += "jobgid=" + encodeURIComponent("" + jobgid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocument(_response);
        });
    }

    protected processGetDocument(response: AxiosResponse): Promise<DocumentModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DocumentModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentModel[]>(null as any);
    }

    /**
     * Delete a document
     * @return OK
     */
    deleteDocument(documentgid: string, cancelToken?: CancelToken): Promise<DocumentModel> {
        let url_ = this.baseUrl + "/api/v1/file/documents/{documentgid}";
        if (documentgid === undefined || documentgid === null)
            throw new globalThis.Error("The parameter 'documentgid' must be defined.");
        url_ = url_.replace("{documentgid}", encodeURIComponent("" + documentgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDocument(_response);
        });
    }

    protected processDeleteDocument(response: AxiosResponse): Promise<DocumentModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DocumentModel.fromJS(resultData200);
            return Promise.resolve<DocumentModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentModel>(null as any);
    }

    /**
     * Update the document
     * @param body (optional) 
     * @return OK
     */
    updateDocument(documentgid: string, body?: DocumentModel | undefined, cancelToken?: CancelToken): Promise<DocumentModel> {
        let url_ = this.baseUrl + "/api/v1/file/documents/{documentgid}";
        if (documentgid === undefined || documentgid === null)
            throw new globalThis.Error("The parameter 'documentgid' must be defined.");
        url_ = url_.replace("{documentgid}", encodeURIComponent("" + documentgid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDocument(_response);
        });
    }

    protected processUpdateDocument(response: AxiosResponse): Promise<DocumentModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DocumentModel.fromJS(resultData200);
            return Promise.resolve<DocumentModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentModel>(null as any);
    }

    /**
     * Get document file
     * @return OK
     */
    downloadDocument(documentgid: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/file/documents/{documentgid}/download";
        if (documentgid === undefined || documentgid === null)
            throw new globalThis.Error("The parameter 'documentgid' must be defined.");
        url_ = url_.replace("{documentgid}", encodeURIComponent("" + documentgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadDocument(_response);
        });
    }

    protected processDownloadDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get the document thumbnail
     * @param jobgid (optional) 
     * @return OK
     */
    getDocumentThumbnail(documentgid: string, jobgid?: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/file/documents/{documentgid}/thumbnail?";
        if (documentgid === undefined || documentgid === null)
            throw new globalThis.Error("The parameter 'documentgid' must be defined.");
        url_ = url_.replace("{documentgid}", encodeURIComponent("" + documentgid));
        if (jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' cannot be null.");
        else if (jobgid !== undefined)
            url_ += "jobgid=" + encodeURIComponent("" + jobgid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "image/jpeg"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentThumbnail(_response);
        });
    }

    protected processGetDocumentThumbnail(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : null as any;
    
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Returns the list of matching suburbs
     * @param q (optional) The partial name of the suburb being searched
     * @return OK
     */
    searchSuburbs(q?: string | undefined, cancelToken?: CancelToken): Promise<PostcodeModel[]> {
        let url_ = this.baseUrl + "/api/v1/gis/suburbs/search?";
        if (q === null)
            throw new globalThis.Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchSuburbs(_response);
        });
    }

    protected processSearchSuburbs(response: AxiosResponse): Promise<PostcodeModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PostcodeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PostcodeModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostcodeModel[]>(null as any);
    }

    /**
     * Returns the list of suburbs for the postcode
     * @return OK
     */
    getSuburbs(postcode: number, cancelToken?: CancelToken): Promise<PostcodeModel[]> {
        let url_ = this.baseUrl + "/api/v1/gis/postcodes/{postcode}/suburbs";
        if (postcode === undefined || postcode === null)
            throw new globalThis.Error("The parameter 'postcode' must be defined.");
        url_ = url_.replace("{postcode}", encodeURIComponent("" + postcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSuburbs(_response);
        });
    }

    protected processGetSuburbs(response: AxiosResponse): Promise<PostcodeModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PostcodeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<PostcodeModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PostcodeModel[]>(null as any);
    }

    /**
     * Returns the list of current travel times
     * @param includeDeleted (optional) Indicates if deleted travel times should also be included in the response
     * @return OK
     */
    getTravelTimes(includeDeleted?: boolean | undefined, cancelToken?: CancelToken): Promise<TravelTimeModel[]> {
        let url_ = this.baseUrl + "/api/v1/gis/traveltimes/list?";
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTravelTimes(_response);
        });
    }

    protected processGetTravelTimes(response: AxiosResponse): Promise<TravelTimeModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TravelTimeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<TravelTimeModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TravelTimeModel[]>(null as any);
    }

    /**
     * Returns the travel time for the specified locality/postcode
     * @param locality (optional) 
     * @param postcode (optional) 
     * @return OK
     */
    lookupTravelTime(locality?: string | undefined, postcode?: string | undefined, cancelToken?: CancelToken): Promise<TravelTimeModel> {
        let url_ = this.baseUrl + "/api/v1/gis/traveltimes/lookup?";
        if (locality === null)
            throw new globalThis.Error("The parameter 'locality' cannot be null.");
        else if (locality !== undefined)
            url_ += "locality=" + encodeURIComponent("" + locality) + "&";
        if (postcode === null)
            throw new globalThis.Error("The parameter 'postcode' cannot be null.");
        else if (postcode !== undefined)
            url_ += "postcode=" + encodeURIComponent("" + postcode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLookupTravelTime(_response);
        });
    }

    protected processLookupTravelTime(response: AxiosResponse): Promise<TravelTimeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TravelTimeModel.fromJS(resultData200);
            return Promise.resolve<TravelTimeModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TravelTimeModel>(null as any);
    }

    /**
     * Create a travel time
     * @param body (optional) 
     * @return OK
     */
    createTravelTime(body?: TravelTimeCreateModel | undefined, cancelToken?: CancelToken): Promise<TravelTimeModel> {
        let url_ = this.baseUrl + "/api/v1/gis/traveltimes/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTravelTime(_response);
        });
    }

    protected processCreateTravelTime(response: AxiosResponse): Promise<TravelTimeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TravelTimeModel.fromJS(resultData200);
            return Promise.resolve<TravelTimeModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TravelTimeModel>(null as any);
    }

    /**
     * Updates a travel time
     * @param body (optional) 
     * @return OK
     */
    updateTravelTime(traveltimegid: string, body?: TravelTimeUpdateModel | undefined, cancelToken?: CancelToken): Promise<TravelTimeModel> {
        let url_ = this.baseUrl + "/api/v1/gis/traveltimes/{traveltimegid}";
        if (traveltimegid === undefined || traveltimegid === null)
            throw new globalThis.Error("The parameter 'traveltimegid' must be defined.");
        url_ = url_.replace("{traveltimegid}", encodeURIComponent("" + traveltimegid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTravelTime(_response);
        });
    }

    protected processUpdateTravelTime(response: AxiosResponse): Promise<TravelTimeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TravelTimeModel.fromJS(resultData200);
            return Promise.resolve<TravelTimeModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TravelTimeModel>(null as any);
    }

    /**
     * Delete the specified travel time
     * @return OK
     */
    deleteTravelTime(traveltimegid: string, cancelToken?: CancelToken): Promise<TravelTimeModel> {
        let url_ = this.baseUrl + "/api/v1/gis/traveltimes/{traveltimegid}";
        if (traveltimegid === undefined || traveltimegid === null)
            throw new globalThis.Error("The parameter 'traveltimegid' must be defined.");
        url_ = url_.replace("{traveltimegid}", encodeURIComponent("" + traveltimegid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTravelTime(_response);
        });
    }

    protected processDeleteTravelTime(response: AxiosResponse): Promise<TravelTimeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TravelTimeModel.fromJS(resultData200);
            return Promise.resolve<TravelTimeModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TravelTimeModel>(null as any);
    }

    /**
     * @param clientgid (optional) 
     * @param networkgid (optional) 
     * @param servicetypegid (optional) 
     * @param body (optional) 
     * @param file (optional) 
     * @return OK
     */
    uploadJobFile(clientgid?: string | undefined, networkgid?: string | undefined, servicetypegid?: string | undefined, body?: Body | undefined, file?: FileParameter | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/data/import/jobfile/upload?";
        if (clientgid === null)
            throw new globalThis.Error("The parameter 'clientgid' cannot be null.");
        else if (clientgid !== undefined)
            url_ += "clientgid=" + encodeURIComponent("" + clientgid) + "&";
        if (networkgid === null)
            throw new globalThis.Error("The parameter 'networkgid' cannot be null.");
        else if (networkgid !== undefined)
            url_ += "networkgid=" + encodeURIComponent("" + networkgid) + "&";
        if (servicetypegid === null)
            throw new globalThis.Error("The parameter 'servicetypegid' cannot be null.");
        else if (servicetypegid !== undefined)
            url_ += "servicetypegid=" + encodeURIComponent("" + servicetypegid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadJobFile(_response);
        });
    }

    protected processUploadJobFile(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    processJobFile(processgid: string, cancelToken?: CancelToken): Promise<ImportJobFileProcessStatusModel> {
        let url_ = this.baseUrl + "/api/v1/data/import/jobfile/process/{processgid}";
        if (processgid === undefined || processgid === null)
            throw new globalThis.Error("The parameter 'processgid' must be defined.");
        url_ = url_.replace("{processgid}", encodeURIComponent("" + processgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessJobFile(_response);
        });
    }

    protected processProcessJobFile(response: AxiosResponse): Promise<ImportJobFileProcessStatusModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportJobFileProcessStatusModel.fromJS(resultData200);
            return Promise.resolve<ImportJobFileProcessStatusModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportJobFileProcessStatusModel>(null as any);
    }

    /**
     * @return OK
     */
    getJobFileStatus(processgid: string, cancelToken?: CancelToken): Promise<ImportJobFileProcessStatusModel> {
        let url_ = this.baseUrl + "/api/v1/data/import/jobfile/status/{processgid}";
        if (processgid === undefined || processgid === null)
            throw new globalThis.Error("The parameter 'processgid' must be defined.");
        url_ = url_.replace("{processgid}", encodeURIComponent("" + processgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobFileStatus(_response);
        });
    }

    protected processGetJobFileStatus(response: AxiosResponse): Promise<ImportJobFileProcessStatusModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportJobFileProcessStatusModel.fromJS(resultData200);
            return Promise.resolve<ImportJobFileProcessStatusModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportJobFileProcessStatusModel>(null as any);
    }

    /**
     * @return OK
     */
    getJobFileValidationResult(processgid: string, cancelToken?: CancelToken): Promise<ImportJobFileValidationResultModel> {
        let url_ = this.baseUrl + "/api/v1/data/import/jobfile/validationresult/{processgid}";
        if (processgid === undefined || processgid === null)
            throw new globalThis.Error("The parameter 'processgid' must be defined.");
        url_ = url_.replace("{processgid}", encodeURIComponent("" + processgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobFileValidationResult(_response);
        });
    }

    protected processGetJobFileValidationResult(response: AxiosResponse): Promise<ImportJobFileValidationResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportJobFileValidationResultModel.fromJS(resultData200);
            return Promise.resolve<ImportJobFileValidationResultModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportJobFileValidationResultModel>(null as any);
    }

    /**
     * @return OK
     */
    getJobFileProcessResult(processgid: string, cancelToken?: CancelToken): Promise<ImportJobFileProcessResultModel> {
        let url_ = this.baseUrl + "/api/v1/data/import/jobfile/processresult/{processgid}";
        if (processgid === undefined || processgid === null)
            throw new globalThis.Error("The parameter 'processgid' must be defined.");
        url_ = url_.replace("{processgid}", encodeURIComponent("" + processgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobFileProcessResult(_response);
        });
    }

    protected processGetJobFileProcessResult(response: AxiosResponse): Promise<ImportJobFileProcessResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportJobFileProcessResultModel.fromJS(resultData200);
            return Promise.resolve<ImportJobFileProcessResultModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportJobFileProcessResultModel>(null as any);
    }

    /**
     * Searches for any matching jobs
     * @param searchCriteria (optional) 
     * @param jobtype (optional) 
     * @param status (optional) 
     * @return OK
     */
    searchJobs(searchCriteria?: string | undefined, jobtype?: string | undefined, status?: string | undefined, cancelToken?: CancelToken): Promise<JobSearchResultModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/search?";
        if (searchCriteria === null)
            throw new globalThis.Error("The parameter 'searchCriteria' cannot be null.");
        else if (searchCriteria !== undefined)
            url_ += "searchCriteria=" + encodeURIComponent("" + searchCriteria) + "&";
        if (jobtype === null)
            throw new globalThis.Error("The parameter 'jobtype' cannot be null.");
        else if (jobtype !== undefined)
            url_ += "jobtype=" + encodeURIComponent("" + jobtype) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchJobs(_response);
        });
    }

    protected processSearchJobs(response: AxiosResponse): Promise<JobSearchResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobSearchResultModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JobSearchResultModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobSearchResultModel[]>(null as any);
    }

    /**
     * Searches for any matching jobs by job item number
     * @param partialJobItemNumber (optional) 
     * @return OK
     */
    searchJobItems(partialJobItemNumber?: string | undefined, cancelToken?: CancelToken): Promise<JobItemByNumberSearchResultModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/jobitems/search/number?";
        if (partialJobItemNumber === null)
            throw new globalThis.Error("The parameter 'partialJobItemNumber' cannot be null.");
        else if (partialJobItemNumber !== undefined)
            url_ += "partialJobItemNumber=" + encodeURIComponent("" + partialJobItemNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearchJobItems(_response);
        });
    }

    protected processSearchJobItems(response: AxiosResponse): Promise<JobItemByNumberSearchResultModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobItemByNumberSearchResultModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JobItemByNumberSearchResultModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemByNumberSearchResultModel[]>(null as any);
    }

    /**
     * Returns job items in Actioned status for invoicing review
     * @param searchCriteria (optional) 
     * @return OK
     */
    getMissedInvoiceJobItems(searchCriteria?: string | undefined, cancelToken?: CancelToken): Promise<MissedInvoiceJobItemModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/jobitems/missed-invoices?";
        if (searchCriteria === null)
            throw new globalThis.Error("The parameter 'searchCriteria' cannot be null.");
        else if (searchCriteria !== undefined)
            url_ += "searchCriteria=" + encodeURIComponent("" + searchCriteria) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMissedInvoiceJobItems(_response);
        });
    }

    protected processGetMissedInvoiceJobItems(response: AxiosResponse): Promise<MissedInvoiceJobItemModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MissedInvoiceJobItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<MissedInvoiceJobItemModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MissedInvoiceJobItemModel[]>(null as any);
    }

    /**
     * Creates a new job and initial job item
     * @param body (optional) 
     * @return OK
     */
    createJob(body?: JobCreateModel | undefined, cancelToken?: CancelToken): Promise<JobModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateJob(_response);
        });
    }

    protected processCreateJob(response: AxiosResponse): Promise<JobModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobModel.fromJS(resultData200);
            return Promise.resolve<JobModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobModel>(null as any);
    }

    /**
     * Update the job with new data
     * @param body (optional) 
     * @return OK
     */
    updateJob(jobgid: string, body?: JobModel | undefined, cancelToken?: CancelToken): Promise<JobModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateJob(_response);
        });
    }

    protected processUpdateJob(response: AxiosResponse): Promise<JobModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobModel.fromJS(resultData200);
            return Promise.resolve<JobModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobModel>(null as any);
    }

    /**
     * Get job details
     * @return OK
     */
    getJob(jobgid: string, cancelToken?: CancelToken): Promise<JobModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJob(_response);
        });
    }

    protected processGetJob(response: AxiosResponse): Promise<JobModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobModel.fromJS(resultData200);
            return Promise.resolve<JobModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobModel>(null as any);
    }

    /**
     * Get all job items for a job
     * @return OK
     */
    getJobItems(jobgid: string, cancelToken?: CancelToken): Promise<JobItemModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/jobitems";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobItems(_response);
        });
    }

    protected processGetJobItems(response: AxiosResponse): Promise<JobItemModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JobItemModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemModel[]>(null as any);
    }

    /**
     * Creates a new job item
     * @param body (optional) 
     * @return OK
     */
    createJobItem(jobgid: string, body?: JobItemModel | undefined, cancelToken?: CancelToken): Promise<JobItemModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/jobitems";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateJobItem(_response);
        });
    }

    protected processCreateJobItem(response: AxiosResponse): Promise<JobItemModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobItemModel.fromJS(resultData200);
            return Promise.resolve<JobItemModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemModel>(null as any);
    }

    /**
     * Update multiple job items for a single job in one atomic process
     * @param body (optional) 
     * @return OK
     */
    updateBulkJobItems(jobgid: string, body?: PostJobItemBulkUpdateRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/jobitems/bulkupdate";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateBulkJobItems(_response);
        });
    }

    protected processUpdateBulkJobItems(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Creates a new job item activity
     * @param body (optional) 
     * @return OK
     */
    createJobItemActivity(jobgid: string, jobitemgid: string, body?: JobItemActivityModel | undefined, cancelToken?: CancelToken): Promise<JobItemActivityModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/jobitems/{jobitemgid}/activities";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (jobitemgid === undefined || jobitemgid === null)
            throw new globalThis.Error("The parameter 'jobitemgid' must be defined.");
        url_ = url_.replace("{jobitemgid}", encodeURIComponent("" + jobitemgid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateJobItemActivity(_response);
        });
    }

    protected processCreateJobItemActivity(response: AxiosResponse): Promise<JobItemActivityModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobItemActivityModel.fromJS(resultData200);
            return Promise.resolve<JobItemActivityModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemActivityModel>(null as any);
    }

    /**
     * Get all job item activities for a job item
     * @return OK
     */
    getJobItemActivities(jobgid: string, jobitemgid: string, cancelToken?: CancelToken): Promise<JobItemActivityModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/jobitems/{jobitemgid}/activities";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (jobitemgid === undefined || jobitemgid === null)
            throw new globalThis.Error("The parameter 'jobitemgid' must be defined.");
        url_ = url_.replace("{jobitemgid}", encodeURIComponent("" + jobitemgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobItemActivities(_response);
        });
    }

    protected processGetJobItemActivities(response: AxiosResponse): Promise<JobItemActivityModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobItemActivityModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JobItemActivityModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemActivityModel[]>(null as any);
    }

    /**
     * Update the job item activity
     * @param body (optional) 
     * @return OK
     */
    updateJobItemActivity(jobgid: string, jobitemgid: string, jobitemactivitygid: string, body?: JobItemActivityModel | undefined, cancelToken?: CancelToken): Promise<JobItemModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/jobitems/{jobitemgid}/activities/{jobitemactivitygid}";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (jobitemgid === undefined || jobitemgid === null)
            throw new globalThis.Error("The parameter 'jobitemgid' must be defined.");
        url_ = url_.replace("{jobitemgid}", encodeURIComponent("" + jobitemgid));
        if (jobitemactivitygid === undefined || jobitemactivitygid === null)
            throw new globalThis.Error("The parameter 'jobitemactivitygid' must be defined.");
        url_ = url_.replace("{jobitemactivitygid}", encodeURIComponent("" + jobitemactivitygid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateJobItemActivity(_response);
        });
    }

    protected processUpdateJobItemActivity(response: AxiosResponse): Promise<JobItemModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobItemModel.fromJS(resultData200);
            return Promise.resolve<JobItemModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemModel>(null as any);
    }

    /**
     * Delete a job activity
     * @return OK
     */
    deleteJobItemActivity(jobgid: string, jobitemgid: string, jobitemactivitygid: string, cancelToken?: CancelToken): Promise<JobItemActivityModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/jobitems/{jobitemgid}/activities/{jobitemactivitygid}";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (jobitemgid === undefined || jobitemgid === null)
            throw new globalThis.Error("The parameter 'jobitemgid' must be defined.");
        url_ = url_.replace("{jobitemgid}", encodeURIComponent("" + jobitemgid));
        if (jobitemactivitygid === undefined || jobitemactivitygid === null)
            throw new globalThis.Error("The parameter 'jobitemactivitygid' must be defined.");
        url_ = url_.replace("{jobitemactivitygid}", encodeURIComponent("" + jobitemactivitygid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteJobItemActivity(_response);
        });
    }

    protected processDeleteJobItemActivity(response: AxiosResponse): Promise<JobItemActivityModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobItemActivityModel.fromJS(resultData200);
            return Promise.resolve<JobItemActivityModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemActivityModel>(null as any);
    }

    /**
     * Get all job item activities for a job (aggregate of all job item activities)
     * @return OK
     */
    getJobActivities(jobgid: string, cancelToken?: CancelToken): Promise<JobItemActivityModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/activities";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobActivities(_response);
        });
    }

    protected processGetJobActivities(response: AxiosResponse): Promise<JobItemActivityModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobItemActivityModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JobItemActivityModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemActivityModel[]>(null as any);
    }

    /**
     * Update the job item
     * @param body (optional) 
     * @return OK
     */
    updateJobItem(jobgid: string, jobitemgid: string, body?: JobItemModel | undefined, cancelToken?: CancelToken): Promise<JobItemModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/jobitems/{jobitemgid}";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (jobitemgid === undefined || jobitemgid === null)
            throw new globalThis.Error("The parameter 'jobitemgid' must be defined.");
        url_ = url_.replace("{jobitemgid}", encodeURIComponent("" + jobitemgid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateJobItem(_response);
        });
    }

    protected processUpdateJobItem(response: AxiosResponse): Promise<JobItemModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobItemModel.fromJS(resultData200);
            return Promise.resolve<JobItemModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemModel>(null as any);
    }

    /**
     * Delete a new job item
     * @return OK
     */
    deleteJobItem(jobgid: string, jobitemgid: string, cancelToken?: CancelToken): Promise<JobItemModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/jobitems/{jobitemgid}";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (jobitemgid === undefined || jobitemgid === null)
            throw new globalThis.Error("The parameter 'jobitemgid' must be defined.");
        url_ = url_.replace("{jobitemgid}", encodeURIComponent("" + jobitemgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteJobItem(_response);
        });
    }

    protected processDeleteJobItem(response: AxiosResponse): Promise<JobItemModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobItemModel.fromJS(resultData200);
            return Promise.resolve<JobItemModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemModel>(null as any);
    }

    /**
     * Cancel the job item, deleting the current schedule and adding in a job note
     * @param body (optional) 
     * @return OK
     */
    cancelJobItem(jobgid: string, jobitemgid: string, body?: JobItemCancelModel | undefined, cancelToken?: CancelToken): Promise<JobItemModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/jobitems/{jobitemgid}/cancel";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (jobitemgid === undefined || jobitemgid === null)
            throw new globalThis.Error("The parameter 'jobitemgid' must be defined.");
        url_ = url_.replace("{jobitemgid}", encodeURIComponent("" + jobitemgid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelJobItem(_response);
        });
    }

    protected processCancelJobItem(response: AxiosResponse): Promise<JobItemModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobItemModel.fromJS(resultData200);
            return Promise.resolve<JobItemModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemModel>(null as any);
    }

    /**
     * Get job locations for the job
     * @return OK
     */
    getJobLocations(jobgid: string, cancelToken?: CancelToken): Promise<LocationModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/locations";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobLocations(_response);
        });
    }

    protected processGetJobLocations(response: AxiosResponse): Promise<LocationModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<LocationModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationModel[]>(null as any);
    }

    /**
     * Creates a new job location
     * @param body (optional) 
     * @return OK
     */
    createJobLocation(jobgid: string, body?: LocationModel | undefined, cancelToken?: CancelToken): Promise<LocationModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/locations";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateJobLocation(_response);
        });
    }

    protected processCreateJobLocation(response: AxiosResponse): Promise<LocationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationModel.fromJS(resultData200);
            return Promise.resolve<LocationModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationModel>(null as any);
    }

    /**
     * Update the job location
     * @param body (optional) 
     * @return OK
     */
    updateJobLocation(jobgid: string, locationgid: string, body?: LocationModel | undefined, cancelToken?: CancelToken): Promise<LocationModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/locations/{locationgid}";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (locationgid === undefined || locationgid === null)
            throw new globalThis.Error("The parameter 'locationgid' must be defined.");
        url_ = url_.replace("{locationgid}", encodeURIComponent("" + locationgid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateJobLocation(_response);
        });
    }

    protected processUpdateJobLocation(response: AxiosResponse): Promise<LocationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationModel.fromJS(resultData200);
            return Promise.resolve<LocationModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationModel>(null as any);
    }

    /**
     * Delete the job location
     * @return OK
     */
    deleteJobLocation(jobgid: string, locationgid: string, cancelToken?: CancelToken): Promise<LocationModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/locations/{locationgid}";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (locationgid === undefined || locationgid === null)
            throw new globalThis.Error("The parameter 'locationgid' must be defined.");
        url_ = url_.replace("{locationgid}", encodeURIComponent("" + locationgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteJobLocation(_response);
        });
    }

    protected processDeleteJobLocation(response: AxiosResponse): Promise<LocationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationModel.fromJS(resultData200);
            return Promise.resolve<LocationModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationModel>(null as any);
    }

    /**
     * Get all invoices associated with this job
     * @return OK
     */
    getJobInvoices(jobgid: string, cancelToken?: CancelToken): Promise<InvoiceModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/invoices";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobInvoices(_response);
        });
    }

    protected processGetJobInvoices(response: AxiosResponse): Promise<InvoiceModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvoiceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<InvoiceModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceModel[]>(null as any);
    }

    /**
     * Creates a new job note
     * @param body (optional) 
     * @return OK
     */
    createJobNote(jobgid: string, body?: JobNoteModel | undefined, cancelToken?: CancelToken): Promise<JobNoteModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/notes";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateJobNote(_response);
        });
    }

    protected processCreateJobNote(response: AxiosResponse): Promise<JobNoteModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobNoteModel.fromJS(resultData200);
            return Promise.resolve<JobNoteModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobNoteModel>(null as any);
    }

    /**
     * Get all job notes for a job
     * @return OK
     */
    getJobNotesForJob(jobgid: string, cancelToken?: CancelToken): Promise<JobNoteModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/notes";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobNotesForJob(_response);
        });
    }

    protected processGetJobNotesForJob(response: AxiosResponse): Promise<JobNoteModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobNoteModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JobNoteModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobNoteModel[]>(null as any);
    }

    /**
     * Update the job note
     * @param body (optional) 
     * @return OK
     */
    updateJobNote(jobgid: string, jobnotegid: string, body?: JobNoteModel | undefined, cancelToken?: CancelToken): Promise<JobItemModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/notes/{jobnotegid}";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (jobnotegid === undefined || jobnotegid === null)
            throw new globalThis.Error("The parameter 'jobnotegid' must be defined.");
        url_ = url_.replace("{jobnotegid}", encodeURIComponent("" + jobnotegid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateJobNote(_response);
        });
    }

    protected processUpdateJobNote(response: AxiosResponse): Promise<JobItemModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobItemModel.fromJS(resultData200);
            return Promise.resolve<JobItemModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemModel>(null as any);
    }

    /**
     * Delete a job note
     * @return OK
     */
    deleteJobNote(jobgid: string, jobnotegid: string, cancelToken?: CancelToken): Promise<JobNoteModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/notes/{jobnotegid}";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (jobnotegid === undefined || jobnotegid === null)
            throw new globalThis.Error("The parameter 'jobnotegid' must be defined.");
        url_ = url_.replace("{jobnotegid}", encodeURIComponent("" + jobnotegid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteJobNote(_response);
        });
    }

    protected processDeleteJobNote(response: AxiosResponse): Promise<JobNoteModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobNoteModel.fromJS(resultData200);
            return Promise.resolve<JobNoteModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobNoteModel>(null as any);
    }

    /**
     * Get all job notes for a job item
     * @return OK
     */
    getJobNotesForJobItem(jobgid: string, jobitemgid: string, cancelToken?: CancelToken): Promise<JobNoteModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/jobitems/{jobitemgid}/notes";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (jobitemgid === undefined || jobitemgid === null)
            throw new globalThis.Error("The parameter 'jobitemgid' must be defined.");
        url_ = url_.replace("{jobitemgid}", encodeURIComponent("" + jobitemgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobNotesForJobItem(_response);
        });
    }

    protected processGetJobNotesForJobItem(response: AxiosResponse): Promise<JobNoteModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobNoteModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JobNoteModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobNoteModel[]>(null as any);
    }

    /**
     * Get all documents for a job
     * @return OK
     */
    getJobDocuments(jobgid: string, cancelToken?: CancelToken): Promise<DocumentModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/documents";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobDocuments(_response);
        });
    }

    protected processGetJobDocuments(response: AxiosResponse): Promise<DocumentModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<DocumentModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentModel[]>(null as any);
    }

    /**
     * Get job schedule for the job item
     * @param jobgid The parent job of the schedule
     * @param jobitemgid The parent job item of the schedule
     * @return OK
     */
    getCurrentJobItemSchedule(jobgid: string, jobitemgid: string, cancelToken?: CancelToken): Promise<JobItemScheduleModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/jobitems/{jobitemgid}/schedules";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (jobitemgid === undefined || jobitemgid === null)
            throw new globalThis.Error("The parameter 'jobitemgid' must be defined.");
        url_ = url_.replace("{jobitemgid}", encodeURIComponent("" + jobitemgid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentJobItemSchedule(_response);
        });
    }

    protected processGetCurrentJobItemSchedule(response: AxiosResponse): Promise<JobItemScheduleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobItemScheduleModel.fromJS(resultData200);
            return Promise.resolve<JobItemScheduleModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemScheduleModel>(null as any);
    }

    /**
     * Get job schedule
     * @param jobgid The parent job of the schedule
     * @param jobitemgid The parent job item of the schedule
     * @param jobitemschedulegid The job item schedule to retrieve
     * @return OK
     */
    getJobItemSchedule(jobgid: string, jobitemgid: string, jobitemschedulegid: string, cancelToken?: CancelToken): Promise<JobItemScheduleModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/jobitems/{jobitemgid}/schedules/{jobitemschedulegid}";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (jobitemgid === undefined || jobitemgid === null)
            throw new globalThis.Error("The parameter 'jobitemgid' must be defined.");
        url_ = url_.replace("{jobitemgid}", encodeURIComponent("" + jobitemgid));
        if (jobitemschedulegid === undefined || jobitemschedulegid === null)
            throw new globalThis.Error("The parameter 'jobitemschedulegid' must be defined.");
        url_ = url_.replace("{jobitemschedulegid}", encodeURIComponent("" + jobitemschedulegid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobItemSchedule(_response);
        });
    }

    protected processGetJobItemSchedule(response: AxiosResponse): Promise<JobItemScheduleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobItemScheduleModel.fromJS(resultData200);
            return Promise.resolve<JobItemScheduleModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemScheduleModel>(null as any);
    }

    /**
     * Sets the scheduled date for the job item
     * @param jobgid The parent job of the job item being scheduled
     * @param jobitemgid The job item being scheduled
     * @param body (optional) The specific details of the schedule
     * @return OK
     */
    scheduleJobItem(jobgid: string, jobitemgid: string, body?: JobItemUpdateScheduleModel | undefined, cancelToken?: CancelToken): Promise<JobItemScheduleModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/jobitems/{jobitemgid}/schedule";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (jobitemgid === undefined || jobitemgid === null)
            throw new globalThis.Error("The parameter 'jobitemgid' must be defined.");
        url_ = url_.replace("{jobitemgid}", encodeURIComponent("" + jobitemgid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScheduleJobItem(_response);
        });
    }

    protected processScheduleJobItem(response: AxiosResponse): Promise<JobItemScheduleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobItemScheduleModel.fromJS(resultData200);
            return Promise.resolve<JobItemScheduleModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemScheduleModel>(null as any);
    }

    /**
     * Unschedules a previously schedules job item.
     * @param jobgid The parent job of the job item being unscheduled
     * @param jobitemgid The job item being unscheduled
     * @param jobitemschedulegid The current schedule item that is to be removed
     * @return OK
     */
    unscheduleJobItem(jobgid: string, jobitemgid: string, jobitemschedulegid: string, cancelToken?: CancelToken): Promise<JobItemModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/jobitems/{jobitemgid}/unschedule/{jobitemschedulegid}";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (jobitemgid === undefined || jobitemgid === null)
            throw new globalThis.Error("The parameter 'jobitemgid' must be defined.");
        url_ = url_.replace("{jobitemgid}", encodeURIComponent("" + jobitemgid));
        if (jobitemschedulegid === undefined || jobitemschedulegid === null)
            throw new globalThis.Error("The parameter 'jobitemschedulegid' must be defined.");
        url_ = url_.replace("{jobitemschedulegid}", encodeURIComponent("" + jobitemschedulegid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnscheduleJobItem(_response);
        });
    }

    protected processUnscheduleJobItem(response: AxiosResponse): Promise<JobItemModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobItemModel.fromJS(resultData200);
            return Promise.resolve<JobItemModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemModel>(null as any);
    }

    /**
     * Assigns an employee to the specific job item schedule
     * @param jobgid The parent job of the job item being scheduled
     * @param jobitemgid The job item being scheduled
     * @param jobitemschedulegid The job item schedule being assigned
     * @param body (optional) The specific employee details of the assignment
     * @return OK
     */
    assignScheduledJobItem(jobgid: string, jobitemgid: string, jobitemschedulegid: string, body?: JobItemScheduleAssignEmployeeModel | undefined, cancelToken?: CancelToken): Promise<JobItemScheduleModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/jobitems/{jobitemgid}/schedule/{jobitemschedulegid}/assign";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (jobitemgid === undefined || jobitemgid === null)
            throw new globalThis.Error("The parameter 'jobitemgid' must be defined.");
        url_ = url_.replace("{jobitemgid}", encodeURIComponent("" + jobitemgid));
        if (jobitemschedulegid === undefined || jobitemschedulegid === null)
            throw new globalThis.Error("The parameter 'jobitemschedulegid' must be defined.");
        url_ = url_.replace("{jobitemschedulegid}", encodeURIComponent("" + jobitemschedulegid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAssignScheduledJobItem(_response);
        });
    }

    protected processAssignScheduledJobItem(response: AxiosResponse): Promise<JobItemScheduleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobItemScheduleModel.fromJS(resultData200);
            return Promise.resolve<JobItemScheduleModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemScheduleModel>(null as any);
    }

    /**
     * Removes employee assigned to the specific job item schedule
     * @param jobgid The parent job of the job item being scheduled
     * @param jobitemgid The job item being scheduled
     * @param jobitemschedulegid The job item schedule being assigned
     * @return OK
     */
    unassignScheduledJobItem(jobgid: string, jobitemgid: string, jobitemschedulegid: string, cancelToken?: CancelToken): Promise<JobItemScheduleModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/{jobgid}/jobitems/{jobitemgid}/schedule/{jobitemschedulegid}/unassign";
        if (jobgid === undefined || jobgid === null)
            throw new globalThis.Error("The parameter 'jobgid' must be defined.");
        url_ = url_.replace("{jobgid}", encodeURIComponent("" + jobgid));
        if (jobitemgid === undefined || jobitemgid === null)
            throw new globalThis.Error("The parameter 'jobitemgid' must be defined.");
        url_ = url_.replace("{jobitemgid}", encodeURIComponent("" + jobitemgid));
        if (jobitemschedulegid === undefined || jobitemschedulegid === null)
            throw new globalThis.Error("The parameter 'jobitemschedulegid' must be defined.");
        url_ = url_.replace("{jobitemschedulegid}", encodeURIComponent("" + jobitemschedulegid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnassignScheduledJobItem(_response);
        });
    }

    protected processUnassignScheduledJobItem(response: AxiosResponse): Promise<JobItemScheduleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobItemScheduleModel.fromJS(resultData200);
            return Promise.resolve<JobItemScheduleModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemScheduleModel>(null as any);
    }

    /**
     * Returns the next available job number from the sequence
     * @return OK
     */
    getNextJobNumber( cancelToken?: CancelToken): Promise<JobNumberModel> {
        let url_ = this.baseUrl + "/api/v1/core/jobs/nextnumber";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNextJobNumber(_response);
        });
    }

    protected processGetNextJobNumber(response: AxiosResponse): Promise<JobNumberModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JobNumberModel.fromJS(resultData200);
            return Promise.resolve<JobNumberModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobNumberModel>(null as any);
    }

    /**
     * Returns the list of current networks
     * @param includeDeleted (optional) Indicates if deleted networks should also be included in the response
     * @return OK
     */
    getNetworks(includeDeleted?: boolean | undefined, cancelToken?: CancelToken): Promise<NetworkModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/networks?";
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNetworks(_response);
        });
    }

    protected processGetNetworks(response: AxiosResponse): Promise<NetworkModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NetworkModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<NetworkModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NetworkModel[]>(null as any);
    }

    /**
     * Returns all of todays scheduled job items
     * @return OK
     */
    getTodaysScheduledJobItems( cancelToken?: CancelToken): Promise<ScheduledJobItemModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/schedule/today";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTodaysScheduledJobItems(_response);
        });
    }

    protected processGetTodaysScheduledJobItems(response: AxiosResponse): Promise<ScheduledJobItemModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduledJobItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ScheduledJobItemModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScheduledJobItemModel[]>(null as any);
    }

    /**
     * Returns all the currently scheduled job items within the specified period
     * @param fromDateISO (optional) Start of date range to query, in format yyyymmdd
     * @param toDateISO (optional) End of date range to query, in format yyyymmdd
     * @param jobType (optional) The job type to filter for. 0 is all job types
     * @return OK
     */
    getScheduledJobItems(fromDateISO?: number | undefined, toDateISO?: number | undefined, jobType?: number | undefined, cancelToken?: CancelToken): Promise<ScheduledJobItemModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/schedule/scheduledjobitems?";
        if (fromDateISO === null)
            throw new globalThis.Error("The parameter 'fromDateISO' cannot be null.");
        else if (fromDateISO !== undefined)
            url_ += "fromDateISO=" + encodeURIComponent("" + fromDateISO) + "&";
        if (toDateISO === null)
            throw new globalThis.Error("The parameter 'toDateISO' cannot be null.");
        else if (toDateISO !== undefined)
            url_ += "toDateISO=" + encodeURIComponent("" + toDateISO) + "&";
        if (jobType === null)
            throw new globalThis.Error("The parameter 'jobType' cannot be null.");
        else if (jobType !== undefined)
            url_ += "jobType=" + encodeURIComponent("" + jobType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetScheduledJobItems(_response);
        });
    }

    protected processGetScheduledJobItems(response: AxiosResponse): Promise<ScheduledJobItemModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduledJobItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ScheduledJobItemModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScheduledJobItemModel[]>(null as any);
    }

    /**
     * Returns all the unscheduled job items whose expected start date falls within the specified period
     * @param fromDateISO (optional) Start of date range to query, in format yyyymmdd
     * @param toDateISO (optional) End of date range to query, in format yyyymmdd
     * @param jobType (optional) The job type to filter for. 0 is all job types
     * @return OK
     */
    getUnscheduledJobItems(fromDateISO?: number | undefined, toDateISO?: number | undefined, jobType?: number | undefined, cancelToken?: CancelToken): Promise<UnscheduledJobItemModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/schedule/unscheduledjobitems?";
        if (fromDateISO === null)
            throw new globalThis.Error("The parameter 'fromDateISO' cannot be null.");
        else if (fromDateISO !== undefined)
            url_ += "fromDateISO=" + encodeURIComponent("" + fromDateISO) + "&";
        if (toDateISO === null)
            throw new globalThis.Error("The parameter 'toDateISO' cannot be null.");
        else if (toDateISO !== undefined)
            url_ += "toDateISO=" + encodeURIComponent("" + toDateISO) + "&";
        if (jobType === null)
            throw new globalThis.Error("The parameter 'jobType' cannot be null.");
        else if (jobType !== undefined)
            url_ += "jobType=" + encodeURIComponent("" + jobType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnscheduledJobItems(_response);
        });
    }

    protected processGetUnscheduledJobItems(response: AxiosResponse): Promise<UnscheduledJobItemModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnscheduledJobItemModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<UnscheduledJobItemModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnscheduledJobItemModel[]>(null as any);
    }

    /**
     * Updates the sequencing for a set of job item schedule objects
     * @param body (optional) 
     * @return OK
     */
    updateJobItemScheduleSequence(body?: JobItemScheduleSequenceModel[] | undefined, cancelToken?: CancelToken): Promise<JobItemScheduleSequenceModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/schedule/updatesequences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateJobItemScheduleSequence(_response);
        });
    }

    protected processUpdateJobItemScheduleSequence(response: AxiosResponse): Promise<JobItemScheduleSequenceModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JobItemScheduleSequenceModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JobItemScheduleSequenceModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JobItemScheduleSequenceModel[]>(null as any);
    }

    /**
     * Returns the list of current service types
     * @param includeDeleted (optional) Indicates if deleted service types should also be included in the response
     * @return OK
     */
    getServiceTypes(includeDeleted?: boolean | undefined, cancelToken?: CancelToken): Promise<ServiceTypeModel[]> {
        let url_ = this.baseUrl + "/api/v1/core/servicetypes?";
        if (includeDeleted === null)
            throw new globalThis.Error("The parameter 'includeDeleted' cannot be null.");
        else if (includeDeleted !== undefined)
            url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceTypes(_response);
        });
    }

    protected processGetServiceTypes(response: AxiosResponse): Promise<ServiceTypeModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceTypeModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ServiceTypeModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceTypeModel[]>(null as any);
    }

    /**
     * Creates a new servicetype
     * @param body (optional) 
     * @return OK
     */
    createServiceType(body?: ServiceTypeCreateModel | undefined, cancelToken?: CancelToken): Promise<ServiceTypeModel> {
        let url_ = this.baseUrl + "/api/v1/core/servicetypes/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateServiceType(_response);
        });
    }

    protected processCreateServiceType(response: AxiosResponse): Promise<ServiceTypeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceTypeModel.fromJS(resultData200);
            return Promise.resolve<ServiceTypeModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceTypeModel>(null as any);
    }

    /**
     * Gets a servicetype from the servicetype gid
     * @return OK
     */
    getServiceType(servicetypegid: string, cancelToken?: CancelToken): Promise<ServiceTypeModel> {
        let url_ = this.baseUrl + "/api/v1/core/servicetypes/{servicetypegid}";
        if (servicetypegid === undefined || servicetypegid === null)
            throw new globalThis.Error("The parameter 'servicetypegid' must be defined.");
        url_ = url_.replace("{servicetypegid}", encodeURIComponent("" + servicetypegid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceType(_response);
        });
    }

    protected processGetServiceType(response: AxiosResponse): Promise<ServiceTypeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceTypeModel.fromJS(resultData200);
            return Promise.resolve<ServiceTypeModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceTypeModel>(null as any);
    }

    /**
     * Updates a servicetype
     * @param body (optional) 
     * @return OK
     */
    updateServiceType(servicetypegid: string, body?: ServiceTypeUpdateModel | undefined, cancelToken?: CancelToken): Promise<ServiceTypeModel> {
        let url_ = this.baseUrl + "/api/v1/core/servicetypes/{servicetypegid}";
        if (servicetypegid === undefined || servicetypegid === null)
            throw new globalThis.Error("The parameter 'servicetypegid' must be defined.");
        url_ = url_.replace("{servicetypegid}", encodeURIComponent("" + servicetypegid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateServiceType(_response);
        });
    }

    protected processUpdateServiceType(response: AxiosResponse): Promise<ServiceTypeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceTypeModel.fromJS(resultData200);
            return Promise.resolve<ServiceTypeModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceTypeModel>(null as any);
    }

    /**
     * Delete the specified servicetype
     * @return OK
     */
    deleteServiceType(servicetypegid: string, cancelToken?: CancelToken): Promise<ServiceTypeModel> {
        let url_ = this.baseUrl + "/api/v1/core/servicetypes/{servicetypegid}";
        if (servicetypegid === undefined || servicetypegid === null)
            throw new globalThis.Error("The parameter 'servicetypegid' must be defined.");
        url_ = url_.replace("{servicetypegid}", encodeURIComponent("" + servicetypegid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteServiceType(_response);
        });
    }

    protected processDeleteServiceType(response: AxiosResponse): Promise<ServiceTypeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceTypeModel.fromJS(resultData200);
            return Promise.resolve<ServiceTypeModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceTypeModel>(null as any);
    }

    /**
     * Returns the list of matching suburbs
     * @return OK
     */
    ping( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/status/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPing(_response);
        });
    }

    protected processPing(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return OK
     */
    testrollbar( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/status/testrollbar";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestrollbar(_response);
        });
    }

    protected processTestrollbar(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Create a new user
     * @param body (optional) UserCerateModel
     * @return OK
     */
    createUser(body?: UserCreateModel | undefined, cancelToken?: CancelToken): Promise<CreateUserResponseModel> {
        let url_ = this.baseUrl + "/api/v1/security/user/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<CreateUserResponseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateUserResponseModel.fromJS(resultData200);
            return Promise.resolve<CreateUserResponseModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ValidationProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateUserResponseModel>(null as any);
    }

    /**
     * Get User Profile
     * @return OK
     */
    getUserProfile( cancelToken?: CancelToken): Promise<UserProfileModel> {
        let url_ = this.baseUrl + "/api/v1/security/user/profile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserProfile(_response);
        });
    }

    protected processGetUserProfile(response: AxiosResponse): Promise<UserProfileModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserProfileModel.fromJS(resultData200);
            return Promise.resolve<UserProfileModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ValidationProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileModel>(null as any);
    }

    /**
     * Change user email
     * @param body (optional) UserEmailModel
     * @return OK
     */
    updateUserEmail(body?: UserEmailModel | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/security/user/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserEmail(_response);
        });
    }

    protected processUpdateUserEmail(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ValidationProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Change User Password
     * @param body (optional) UserPasswordModel
     * @return OK
     */
    updateUserPassword(body?: UserPasswordModel | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/security/user/password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUserPassword(_response);
        });
    }

    protected processUpdateUserPassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ValidationProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Request reset of user password
     * @param body (optional) RequestResetPasswordModel
     * @return OK
     */
    requestResetPassword(body?: RequestResetPasswordModel | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/security/user/resetpassword/request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRequestResetPassword(_response);
        });
    }

    protected processRequestResetPassword(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<boolean>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ValidationProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Complete reset of user password
     * @param body (optional) RequestResetPasswordModel
     * @return OK
     */
    completeResetPassword(body?: CompleteResetPasswordModel | undefined, cancelToken?: CancelToken): Promise<ResetPasswordResultModel> {
        let url_ = this.baseUrl + "/api/v1/security/user/resetpassword/complete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCompleteResetPassword(_response);
        });
    }

    protected processCompleteResetPassword(response: AxiosResponse): Promise<ResetPasswordResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ResetPasswordResultModel.fromJS(resultData200);
            return Promise.resolve<ResetPasswordResultModel>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = ValidationProblemDetails.fromJS(resultData422);
            return throwException("Unprocessable Content", status, _responseText, _headers, result422);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ValidationProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ResetPasswordResultModel>(null as any);
    }
}

export enum ActivityInvoiceType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum AreaType {
    _0 = 0,
    _1 = 1,
}

export class ClientCreateModel implements IClientCreateModel {
    gid?: string;
    name?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    locality?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;
    contactName?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    position?: string | undefined;

    constructor(data?: IClientCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressLine3 = _data["addressLine3"];
            this.locality = _data["locality"];
            this.region = _data["region"];
            this.postcode = _data["postcode"];
            this.contactName = _data["contactName"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): ClientCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressLine3"] = this.addressLine3;
        data["locality"] = this.locality;
        data["region"] = this.region;
        data["postcode"] = this.postcode;
        data["contactName"] = this.contactName;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        data["position"] = this.position;
        return data;
    }
}

export interface IClientCreateModel {
    gid?: string;
    name?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    locality?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;
    contactName?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    position?: string | undefined;
}

export class ClientModel implements IClientModel {
    gid?: string;
    isDeleted?: boolean;
    name?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    locality?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;
    contacts?: ContactModel[] | undefined;

    constructor(data?: IClientModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressLine3 = _data["addressLine3"];
            this.locality = _data["locality"];
            this.region = _data["region"];
            this.postcode = _data["postcode"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(ContactModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClientModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressLine3"] = this.addressLine3;
        data["locality"] = this.locality;
        data["region"] = this.region;
        data["postcode"] = this.postcode;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IClientModel {
    gid?: string;
    isDeleted?: boolean;
    name?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    locality?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;
    contacts?: ContactModel[] | undefined;
}

export class ClientSearchResultModel implements IClientSearchResultModel {
    gid?: string;
    name?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    locality?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;
    hasActiveJobs?: boolean;

    constructor(data?: IClientSearchResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressLine3 = _data["addressLine3"];
            this.locality = _data["locality"];
            this.region = _data["region"];
            this.postcode = _data["postcode"];
            this.hasActiveJobs = _data["hasActiveJobs"];
        }
    }

    static fromJS(data: any): ClientSearchResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientSearchResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressLine3"] = this.addressLine3;
        data["locality"] = this.locality;
        data["region"] = this.region;
        data["postcode"] = this.postcode;
        data["hasActiveJobs"] = this.hasActiveJobs;
        return data;
    }
}

export interface IClientSearchResultModel {
    gid?: string;
    name?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    locality?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;
    hasActiveJobs?: boolean;
}

export class ClientUpdateModel implements IClientUpdateModel {
    gid?: string;
    name?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    locality?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;

    constructor(data?: IClientUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressLine3 = _data["addressLine3"];
            this.locality = _data["locality"];
            this.region = _data["region"];
            this.postcode = _data["postcode"];
        }
    }

    static fromJS(data: any): ClientUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressLine3"] = this.addressLine3;
        data["locality"] = this.locality;
        data["region"] = this.region;
        data["postcode"] = this.postcode;
        return data;
    }
}

export interface IClientUpdateModel {
    gid?: string;
    name?: string | undefined;
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    locality?: string | undefined;
    region?: string | undefined;
    postcode?: string | undefined;
}

export class CompleteResetPasswordModel implements ICompleteResetPasswordModel {
    /** New Password */
    newPassword!: string;
    token!: string;
    userId!: string;

    constructor(data?: ICompleteResetPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newPassword = _data["newPassword"];
            this.token = _data["token"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CompleteResetPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new CompleteResetPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newPassword"] = this.newPassword;
        data["token"] = this.token;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ICompleteResetPasswordModel {
    /** New Password */
    newPassword: string;
    token: string;
    userId: string;
}

export class ContactCreateModel implements IContactCreateModel {
    gid?: string;
    clientGid?: string;
    name?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    position?: string | undefined;

    constructor(data?: IContactCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.clientGid = _data["clientGid"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): ContactCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["clientGid"] = this.clientGid;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        data["position"] = this.position;
        return data;
    }
}

export interface IContactCreateModel {
    gid?: string;
    clientGid?: string;
    name?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    position?: string | undefined;
}

export class ContactModel implements IContactModel {
    gid?: string;
    clientGid?: string;
    isDeleted?: boolean;
    name?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    position?: string | undefined;

    constructor(data?: IContactModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.clientGid = _data["clientGid"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): ContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["clientGid"] = this.clientGid;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        data["position"] = this.position;
        return data;
    }
}

export interface IContactModel {
    gid?: string;
    clientGid?: string;
    isDeleted?: boolean;
    name?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    position?: string | undefined;
}

export class ContactUpdateModel implements IContactUpdateModel {
    gid?: string;
    name?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    position?: string | undefined;

    constructor(data?: IContactUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            this.position = _data["position"];
        }
    }

    static fromJS(data: any): ContactUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        data["position"] = this.position;
        return data;
    }
}

export interface IContactUpdateModel {
    gid?: string;
    name?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    position?: string | undefined;
}

export class CreateInvoiceBatchRequestModel implements ICreateInvoiceBatchRequestModel {
    batchName?: string | undefined;
    openDateTimeUtc?: Date;
    defaultInvoiceDate?: Date;
    useActivityDateAsInvoiceDate?: boolean;
    clientGid?: string | undefined;

    constructor(data?: ICreateInvoiceBatchRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.batchName = _data["batchName"];
            this.openDateTimeUtc = _data["openDateTimeUtc"] ? new Date(_data["openDateTimeUtc"].toString()) : undefined as any;
            this.defaultInvoiceDate = _data["defaultInvoiceDate"] ? new Date(_data["defaultInvoiceDate"].toString()) : undefined as any;
            this.useActivityDateAsInvoiceDate = _data["useActivityDateAsInvoiceDate"];
            this.clientGid = _data["clientGid"];
        }
    }

    static fromJS(data: any): CreateInvoiceBatchRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceBatchRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["batchName"] = this.batchName;
        data["openDateTimeUtc"] = this.openDateTimeUtc ? this.openDateTimeUtc.toISOString() : undefined as any;
        data["defaultInvoiceDate"] = this.defaultInvoiceDate ? this.defaultInvoiceDate.toISOString() : undefined as any;
        data["useActivityDateAsInvoiceDate"] = this.useActivityDateAsInvoiceDate;
        data["clientGid"] = this.clientGid;
        return data;
    }
}

export interface ICreateInvoiceBatchRequestModel {
    batchName?: string | undefined;
    openDateTimeUtc?: Date;
    defaultInvoiceDate?: Date;
    useActivityDateAsInvoiceDate?: boolean;
    clientGid?: string | undefined;
}

export class CreateInvoiceRequestLineItemModel implements ICreateInvoiceRequestLineItemModel {
    accountCode?: string | undefined;
    amountUnit?: number;
    quantity?: number;
    description?: string | undefined;
    comment?: string | undefined;
    amountExTax?: number;
    amountTax?: number;
    amountIncTax?: number;
    jobItemActivityGids?: string[] | undefined;

    constructor(data?: ICreateInvoiceRequestLineItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountCode = _data["accountCode"];
            this.amountUnit = _data["amountUnit"];
            this.quantity = _data["quantity"];
            this.description = _data["description"];
            this.comment = _data["comment"];
            this.amountExTax = _data["amountExTax"];
            this.amountTax = _data["amountTax"];
            this.amountIncTax = _data["amountIncTax"];
            if (Array.isArray(_data["jobItemActivityGids"])) {
                this.jobItemActivityGids = [] as any;
                for (let item of _data["jobItemActivityGids"])
                    this.jobItemActivityGids!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateInvoiceRequestLineItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceRequestLineItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountCode"] = this.accountCode;
        data["amountUnit"] = this.amountUnit;
        data["quantity"] = this.quantity;
        data["description"] = this.description;
        data["comment"] = this.comment;
        data["amountExTax"] = this.amountExTax;
        data["amountTax"] = this.amountTax;
        data["amountIncTax"] = this.amountIncTax;
        if (Array.isArray(this.jobItemActivityGids)) {
            data["jobItemActivityGids"] = [];
            for (let item of this.jobItemActivityGids)
                data["jobItemActivityGids"].push(item);
        }
        return data;
    }
}

export interface ICreateInvoiceRequestLineItemModel {
    accountCode?: string | undefined;
    amountUnit?: number;
    quantity?: number;
    description?: string | undefined;
    comment?: string | undefined;
    amountExTax?: number;
    amountTax?: number;
    amountIncTax?: number;
    jobItemActivityGids?: string[] | undefined;
}

export class CreateInvoiceRequestModel implements ICreateInvoiceRequestModel {
    invoiceBatchGid?: string | undefined;
    clientGid?: string;
    jobGid?: string;
    createdByUserGid?: string;
    invoiceDate?: Date;
    amountExTax?: number;
    amountTax?: number;
    amountIncTax?: number;
    paid?: boolean;
    amountPaid?: number;
    lineItems?: CreateInvoiceRequestLineItemModel[] | undefined;

    constructor(data?: ICreateInvoiceRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceBatchGid = _data["invoiceBatchGid"];
            this.clientGid = _data["clientGid"];
            this.jobGid = _data["jobGid"];
            this.createdByUserGid = _data["createdByUserGid"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.amountExTax = _data["amountExTax"];
            this.amountTax = _data["amountTax"];
            this.amountIncTax = _data["amountIncTax"];
            this.paid = _data["paid"];
            this.amountPaid = _data["amountPaid"];
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(CreateInvoiceRequestLineItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateInvoiceRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceBatchGid"] = this.invoiceBatchGid;
        data["clientGid"] = this.clientGid;
        data["jobGid"] = this.jobGid;
        data["createdByUserGid"] = this.createdByUserGid;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["amountExTax"] = this.amountExTax;
        data["amountTax"] = this.amountTax;
        data["amountIncTax"] = this.amountIncTax;
        data["paid"] = this.paid;
        data["amountPaid"] = this.amountPaid;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICreateInvoiceRequestModel {
    invoiceBatchGid?: string | undefined;
    clientGid?: string;
    jobGid?: string;
    createdByUserGid?: string;
    invoiceDate?: Date;
    amountExTax?: number;
    amountTax?: number;
    amountIncTax?: number;
    paid?: boolean;
    amountPaid?: number;
    lineItems?: CreateInvoiceRequestLineItemModel[] | undefined;
}

export class CreateUserResponseModel implements ICreateUserResponseModel {
    success?: boolean;
    message?: string | undefined;

    constructor(data?: ICreateUserResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateUserResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface ICreateUserResponseModel {
    success?: boolean;
    message?: string | undefined;
}

export class DocumentModel implements IDocumentModel {
    gid?: string;
    name?: string | undefined;
    type?: DocumentType;
    fileName?: string | undefined;
    sizeInBytes?: number;
    fileType?: string | undefined;
    uploadedBy?: string | undefined;
    uploadedDateTime?: Date;
    jobGid?: string;
    job?: JobModel;
    folderName?: string | undefined;

    constructor(data?: IDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.fileName = _data["fileName"];
            this.sizeInBytes = _data["sizeInBytes"];
            this.fileType = _data["fileType"];
            this.uploadedBy = _data["uploadedBy"];
            this.uploadedDateTime = _data["uploadedDateTime"] ? new Date(_data["uploadedDateTime"].toString()) : undefined as any;
            this.jobGid = _data["jobGid"];
            this.job = _data["job"] ? JobModel.fromJS(_data["job"]) : undefined as any;
            this.folderName = _data["folderName"];
        }
    }

    static fromJS(data: any): DocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        data["type"] = this.type;
        data["fileName"] = this.fileName;
        data["sizeInBytes"] = this.sizeInBytes;
        data["fileType"] = this.fileType;
        data["uploadedBy"] = this.uploadedBy;
        data["uploadedDateTime"] = this.uploadedDateTime ? this.uploadedDateTime.toISOString() : undefined as any;
        data["jobGid"] = this.jobGid;
        data["job"] = this.job ? this.job.toJSON() : undefined as any;
        data["folderName"] = this.folderName;
        return data;
    }
}

export interface IDocumentModel {
    gid?: string;
    name?: string | undefined;
    type?: DocumentType;
    fileName?: string | undefined;
    sizeInBytes?: number;
    fileType?: string | undefined;
    uploadedBy?: string | undefined;
    uploadedDateTime?: Date;
    jobGid?: string;
    job?: JobModel;
    folderName?: string | undefined;
}

export enum DocumentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class EmployeeCreateModel implements IEmployeeCreateModel {
    gid?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isDeleted?: boolean;
    assignableJobItemTypes?: JobItemType[] | undefined;

    constructor(data?: IEmployeeCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["assignableJobItemTypes"])) {
                this.assignableJobItemTypes = [] as any;
                for (let item of _data["assignableJobItemTypes"])
                    this.assignableJobItemTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): EmployeeCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.assignableJobItemTypes)) {
            data["assignableJobItemTypes"] = [];
            for (let item of this.assignableJobItemTypes)
                data["assignableJobItemTypes"].push(item);
        }
        return data;
    }
}

export interface IEmployeeCreateModel {
    gid?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isDeleted?: boolean;
    assignableJobItemTypes?: JobItemType[] | undefined;
}

export class EmployeeModel implements IEmployeeModel {
    gid?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isDeleted?: boolean;
    assignableJobItemTypes?: JobItemType[] | undefined;

    constructor(data?: IEmployeeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["assignableJobItemTypes"])) {
                this.assignableJobItemTypes = [] as any;
                for (let item of _data["assignableJobItemTypes"])
                    this.assignableJobItemTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): EmployeeModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.assignableJobItemTypes)) {
            data["assignableJobItemTypes"] = [];
            for (let item of this.assignableJobItemTypes)
                data["assignableJobItemTypes"].push(item);
        }
        return data;
    }
}

export interface IEmployeeModel {
    gid?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isDeleted?: boolean;
    assignableJobItemTypes?: JobItemType[] | undefined;
}

export class EmployeeUpdateModel implements IEmployeeUpdateModel {
    gid?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isDeleted?: boolean;
    assignableJobItemTypes?: JobItemType[] | undefined;

    constructor(data?: IEmployeeUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.isDeleted = _data["isDeleted"];
            if (Array.isArray(_data["assignableJobItemTypes"])) {
                this.assignableJobItemTypes = [] as any;
                for (let item of _data["assignableJobItemTypes"])
                    this.assignableJobItemTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): EmployeeUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isDeleted"] = this.isDeleted;
        if (Array.isArray(this.assignableJobItemTypes)) {
            data["assignableJobItemTypes"] = [];
            for (let item of this.assignableJobItemTypes)
                data["assignableJobItemTypes"].push(item);
        }
        return data;
    }
}

export interface IEmployeeUpdateModel {
    gid?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    isDeleted?: boolean;
    assignableJobItemTypes?: JobItemType[] | undefined;
}

export class ImportJobFileItemSummaryModel implements IImportJobFileItemSummaryModel {
    processedCount?: number;
    okCount?: number;
    warningCount?: number;
    errorCount?: number;

    constructor(data?: IImportJobFileItemSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processedCount = _data["processedCount"];
            this.okCount = _data["okCount"];
            this.warningCount = _data["warningCount"];
            this.errorCount = _data["errorCount"];
        }
    }

    static fromJS(data: any): ImportJobFileItemSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImportJobFileItemSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processedCount"] = this.processedCount;
        data["okCount"] = this.okCount;
        data["warningCount"] = this.warningCount;
        data["errorCount"] = this.errorCount;
        return data;
    }
}

export interface IImportJobFileItemSummaryModel {
    processedCount?: number;
    okCount?: number;
    warningCount?: number;
    errorCount?: number;
}

export class ImportJobFileProcessItemResultModel implements IImportJobFileProcessItemResultModel {
    jobGid?: string | undefined;
    level?: MessageLevel;
    workOrderNumber?: string | undefined;
    message?: string | undefined;

    constructor(data?: IImportJobFileProcessItemResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobGid = _data["jobGid"];
            this.level = _data["level"];
            this.workOrderNumber = _data["workOrderNumber"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ImportJobFileProcessItemResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImportJobFileProcessItemResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobGid"] = this.jobGid;
        data["level"] = this.level;
        data["workOrderNumber"] = this.workOrderNumber;
        data["message"] = this.message;
        return data;
    }
}

export interface IImportJobFileProcessItemResultModel {
    jobGid?: string | undefined;
    level?: MessageLevel;
    workOrderNumber?: string | undefined;
    message?: string | undefined;
}

export class ImportJobFileProcessResultModel implements IImportJobFileProcessResultModel {
    items?: ImportJobFileProcessItemResultModel[] | undefined;

    constructor(data?: IImportJobFileProcessResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ImportJobFileProcessItemResultModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportJobFileProcessResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImportJobFileProcessResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImportJobFileProcessResultModel {
    items?: ImportJobFileProcessItemResultModel[] | undefined;
}

export class ImportJobFileProcessStatusModel implements IImportJobFileProcessStatusModel {
    message?: string | undefined;
    validationCompleted?: boolean;
    validationSummary?: ImportJobFileItemSummaryModel;
    importCompleted?: boolean;
    importSummary?: ImportJobFileItemSummaryModel;

    constructor(data?: IImportJobFileProcessStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.validationCompleted = _data["validationCompleted"];
            this.validationSummary = _data["validationSummary"] ? ImportJobFileItemSummaryModel.fromJS(_data["validationSummary"]) : undefined as any;
            this.importCompleted = _data["importCompleted"];
            this.importSummary = _data["importSummary"] ? ImportJobFileItemSummaryModel.fromJS(_data["importSummary"]) : undefined as any;
        }
    }

    static fromJS(data: any): ImportJobFileProcessStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImportJobFileProcessStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["validationCompleted"] = this.validationCompleted;
        data["validationSummary"] = this.validationSummary ? this.validationSummary.toJSON() : undefined as any;
        data["importCompleted"] = this.importCompleted;
        data["importSummary"] = this.importSummary ? this.importSummary.toJSON() : undefined as any;
        return data;
    }
}

export interface IImportJobFileProcessStatusModel {
    message?: string | undefined;
    validationCompleted?: boolean;
    validationSummary?: ImportJobFileItemSummaryModel;
    importCompleted?: boolean;
    importSummary?: ImportJobFileItemSummaryModel;
}

export class ImportJobFileValidationItemResultModel implements IImportJobFileValidationItemResultModel {
    row?: number;
    level?: MessageLevel;
    workOrderNumber?: string | undefined;
    message?: string | undefined;

    constructor(data?: IImportJobFileValidationItemResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.row = _data["row"];
            this.level = _data["level"];
            this.workOrderNumber = _data["workOrderNumber"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ImportJobFileValidationItemResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImportJobFileValidationItemResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["row"] = this.row;
        data["level"] = this.level;
        data["workOrderNumber"] = this.workOrderNumber;
        data["message"] = this.message;
        return data;
    }
}

export interface IImportJobFileValidationItemResultModel {
    row?: number;
    level?: MessageLevel;
    workOrderNumber?: string | undefined;
    message?: string | undefined;
}

export class ImportJobFileValidationResultModel implements IImportJobFileValidationResultModel {
    items?: ImportJobFileValidationItemResultModel[] | undefined;

    constructor(data?: IImportJobFileValidationResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ImportJobFileValidationItemResultModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImportJobFileValidationResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImportJobFileValidationResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IImportJobFileValidationResultModel {
    items?: ImportJobFileValidationItemResultModel[] | undefined;
}

export class InvoiceBatchModel implements IInvoiceBatchModel {
    gid?: string;
    isDeleted?: boolean;
    batchName?: string | undefined;
    openDateTimeUtc?: Date;
    closedDateTimeUtc?: Date | undefined;
    defaultInvoiceDate?: Date;
    useActivityDateAsInvoiceDate?: boolean;
    isClientBatch?: boolean;
    clientName?: string | undefined;
    clientGid?: string | undefined;
    invoiceCount?: number;

    constructor(data?: IInvoiceBatchModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.isDeleted = _data["isDeleted"];
            this.batchName = _data["batchName"];
            this.openDateTimeUtc = _data["openDateTimeUtc"] ? new Date(_data["openDateTimeUtc"].toString()) : undefined as any;
            this.closedDateTimeUtc = _data["closedDateTimeUtc"] ? new Date(_data["closedDateTimeUtc"].toString()) : undefined as any;
            this.defaultInvoiceDate = _data["defaultInvoiceDate"] ? new Date(_data["defaultInvoiceDate"].toString()) : undefined as any;
            this.useActivityDateAsInvoiceDate = _data["useActivityDateAsInvoiceDate"];
            this.isClientBatch = _data["isClientBatch"];
            this.clientName = _data["clientName"];
            this.clientGid = _data["clientGid"];
            this.invoiceCount = _data["invoiceCount"];
        }
    }

    static fromJS(data: any): InvoiceBatchModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceBatchModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["isDeleted"] = this.isDeleted;
        data["batchName"] = this.batchName;
        data["openDateTimeUtc"] = this.openDateTimeUtc ? this.openDateTimeUtc.toISOString() : undefined as any;
        data["closedDateTimeUtc"] = this.closedDateTimeUtc ? this.closedDateTimeUtc.toISOString() : undefined as any;
        data["defaultInvoiceDate"] = this.defaultInvoiceDate ? this.defaultInvoiceDate.toISOString() : undefined as any;
        data["useActivityDateAsInvoiceDate"] = this.useActivityDateAsInvoiceDate;
        data["isClientBatch"] = this.isClientBatch;
        data["clientName"] = this.clientName;
        data["clientGid"] = this.clientGid;
        data["invoiceCount"] = this.invoiceCount;
        return data;
    }
}

export interface IInvoiceBatchModel {
    gid?: string;
    isDeleted?: boolean;
    batchName?: string | undefined;
    openDateTimeUtc?: Date;
    closedDateTimeUtc?: Date | undefined;
    defaultInvoiceDate?: Date;
    useActivityDateAsInvoiceDate?: boolean;
    isClientBatch?: boolean;
    clientName?: string | undefined;
    clientGid?: string | undefined;
    invoiceCount?: number;
}

export class InvoiceModel implements IInvoiceModel {
    gid?: string;
    isDeleted?: boolean;
    createdDateTimeUtc?: Date;
    createdByUserGid?: string;
    createdByUser?: UserModel;
    invoiceBatchGid?: string | undefined;
    invoiceBatch?: InvoiceBatchModel;
    clientGid?: string;
    client?: ClientModel;
    jobGid?: string;
    job?: JobModel;
    invoiceNumber?: string | undefined;
    invoiceDate?: Date;
    amountExTax?: number;
    amountTax?: number;
    amountIncTax?: number;
    paid?: boolean;
    amountPaid?: number;
    lineItems?: LineItemModel[] | undefined;

    constructor(data?: IInvoiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.isDeleted = _data["isDeleted"];
            this.createdDateTimeUtc = _data["createdDateTimeUtc"] ? new Date(_data["createdDateTimeUtc"].toString()) : undefined as any;
            this.createdByUserGid = _data["createdByUserGid"];
            this.createdByUser = _data["createdByUser"] ? UserModel.fromJS(_data["createdByUser"]) : undefined as any;
            this.invoiceBatchGid = _data["invoiceBatchGid"];
            this.invoiceBatch = _data["invoiceBatch"] ? InvoiceBatchModel.fromJS(_data["invoiceBatch"]) : undefined as any;
            this.clientGid = _data["clientGid"];
            this.client = _data["client"] ? ClientModel.fromJS(_data["client"]) : undefined as any;
            this.jobGid = _data["jobGid"];
            this.job = _data["job"] ? JobModel.fromJS(_data["job"]) : undefined as any;
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.amountExTax = _data["amountExTax"];
            this.amountTax = _data["amountTax"];
            this.amountIncTax = _data["amountIncTax"];
            this.paid = _data["paid"];
            this.amountPaid = _data["amountPaid"];
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(LineItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvoiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["isDeleted"] = this.isDeleted;
        data["createdDateTimeUtc"] = this.createdDateTimeUtc ? this.createdDateTimeUtc.toISOString() : undefined as any;
        data["createdByUserGid"] = this.createdByUserGid;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        data["invoiceBatchGid"] = this.invoiceBatchGid;
        data["invoiceBatch"] = this.invoiceBatch ? this.invoiceBatch.toJSON() : undefined as any;
        data["clientGid"] = this.clientGid;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["jobGid"] = this.jobGid;
        data["job"] = this.job ? this.job.toJSON() : undefined as any;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["amountExTax"] = this.amountExTax;
        data["amountTax"] = this.amountTax;
        data["amountIncTax"] = this.amountIncTax;
        data["paid"] = this.paid;
        data["amountPaid"] = this.amountPaid;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IInvoiceModel {
    gid?: string;
    isDeleted?: boolean;
    createdDateTimeUtc?: Date;
    createdByUserGid?: string;
    createdByUser?: UserModel;
    invoiceBatchGid?: string | undefined;
    invoiceBatch?: InvoiceBatchModel;
    clientGid?: string;
    client?: ClientModel;
    jobGid?: string;
    job?: JobModel;
    invoiceNumber?: string | undefined;
    invoiceDate?: Date;
    amountExTax?: number;
    amountTax?: number;
    amountIncTax?: number;
    paid?: boolean;
    amountPaid?: number;
    lineItems?: LineItemModel[] | undefined;
}

export class JobCreateModel implements IJobCreateModel {
    jobName?: string | undefined;
    networkGid?: string;
    clientGid?: string;
    workOrderNumber?: string | undefined;
    jobNumber?: string | undefined;
    externalReferenceNumber?: string | undefined;
    jobType?: JobType;
    initiatorName?: string | undefined;
    initiatorPhoneNumber?: string | undefined;
    siteContactName?: string | undefined;
    siteContactPhoneNumber?: string | undefined;
    projectDescription?: string | undefined;
    isQuotedProject?: boolean;
    itemName?: string | undefined;
    jobItemType?: JobItemType;
    serviceTypeGid?: string;
    expectedStartDate?: Date | undefined;
    status?: Status;
    jobItemNumber?: number;
    isFullDay?: boolean;
    purchaseOrderNumber?: string | undefined;
    contactName?: string | undefined;
    contactPhoneNumber?: string | undefined;
    isAdditionalToQuotedProjectScope?: boolean;
    quoteValue?: number;
    suburb?: string | undefined;
    postcode?: string | undefined;
    address?: string | undefined;
    gridReference?: string | undefined;
    locationIdentifier?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    area?: AreaType;
    regionGid?: string;
    scheduledDate?: Date | undefined;
    scheduledTimeRange?: string | undefined;
    estimatedDurationInMinutes?: number;
    estimatedTravelTimeInMinutes?: number;
    assignedToEmployeeGid?: string | undefined;

    constructor(data?: IJobCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobName = _data["jobName"];
            this.networkGid = _data["networkGid"];
            this.clientGid = _data["clientGid"];
            this.workOrderNumber = _data["workOrderNumber"];
            this.jobNumber = _data["jobNumber"];
            this.externalReferenceNumber = _data["externalReferenceNumber"];
            this.jobType = _data["jobType"];
            this.initiatorName = _data["initiatorName"];
            this.initiatorPhoneNumber = _data["initiatorPhoneNumber"];
            this.siteContactName = _data["siteContactName"];
            this.siteContactPhoneNumber = _data["siteContactPhoneNumber"];
            this.projectDescription = _data["projectDescription"];
            this.isQuotedProject = _data["isQuotedProject"];
            this.itemName = _data["itemName"];
            this.jobItemType = _data["jobItemType"];
            this.serviceTypeGid = _data["serviceTypeGid"];
            this.expectedStartDate = _data["expectedStartDate"] ? new Date(_data["expectedStartDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.jobItemNumber = _data["jobItemNumber"];
            this.isFullDay = _data["isFullDay"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.contactName = _data["contactName"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.isAdditionalToQuotedProjectScope = _data["isAdditionalToQuotedProjectScope"];
            this.quoteValue = _data["quoteValue"];
            this.suburb = _data["suburb"];
            this.postcode = _data["postcode"];
            this.address = _data["address"];
            this.gridReference = _data["gridReference"];
            this.locationIdentifier = _data["locationIdentifier"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.area = _data["area"];
            this.regionGid = _data["regionGid"];
            this.scheduledDate = _data["scheduledDate"] ? new Date(_data["scheduledDate"].toString()) : undefined as any;
            this.scheduledTimeRange = _data["scheduledTimeRange"];
            this.estimatedDurationInMinutes = _data["estimatedDurationInMinutes"];
            this.estimatedTravelTimeInMinutes = _data["estimatedTravelTimeInMinutes"];
            this.assignedToEmployeeGid = _data["assignedToEmployeeGid"];
        }
    }

    static fromJS(data: any): JobCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobName"] = this.jobName;
        data["networkGid"] = this.networkGid;
        data["clientGid"] = this.clientGid;
        data["workOrderNumber"] = this.workOrderNumber;
        data["jobNumber"] = this.jobNumber;
        data["externalReferenceNumber"] = this.externalReferenceNumber;
        data["jobType"] = this.jobType;
        data["initiatorName"] = this.initiatorName;
        data["initiatorPhoneNumber"] = this.initiatorPhoneNumber;
        data["siteContactName"] = this.siteContactName;
        data["siteContactPhoneNumber"] = this.siteContactPhoneNumber;
        data["projectDescription"] = this.projectDescription;
        data["isQuotedProject"] = this.isQuotedProject;
        data["itemName"] = this.itemName;
        data["jobItemType"] = this.jobItemType;
        data["serviceTypeGid"] = this.serviceTypeGid;
        data["expectedStartDate"] = this.expectedStartDate ? this.expectedStartDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["jobItemNumber"] = this.jobItemNumber;
        data["isFullDay"] = this.isFullDay;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["contactName"] = this.contactName;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["isAdditionalToQuotedProjectScope"] = this.isAdditionalToQuotedProjectScope;
        data["quoteValue"] = this.quoteValue;
        data["suburb"] = this.suburb;
        data["postcode"] = this.postcode;
        data["address"] = this.address;
        data["gridReference"] = this.gridReference;
        data["locationIdentifier"] = this.locationIdentifier;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["area"] = this.area;
        data["regionGid"] = this.regionGid;
        data["scheduledDate"] = this.scheduledDate ? this.scheduledDate.toISOString() : undefined as any;
        data["scheduledTimeRange"] = this.scheduledTimeRange;
        data["estimatedDurationInMinutes"] = this.estimatedDurationInMinutes;
        data["estimatedTravelTimeInMinutes"] = this.estimatedTravelTimeInMinutes;
        data["assignedToEmployeeGid"] = this.assignedToEmployeeGid;
        return data;
    }
}

export interface IJobCreateModel {
    jobName?: string | undefined;
    networkGid?: string;
    clientGid?: string;
    workOrderNumber?: string | undefined;
    jobNumber?: string | undefined;
    externalReferenceNumber?: string | undefined;
    jobType?: JobType;
    initiatorName?: string | undefined;
    initiatorPhoneNumber?: string | undefined;
    siteContactName?: string | undefined;
    siteContactPhoneNumber?: string | undefined;
    projectDescription?: string | undefined;
    isQuotedProject?: boolean;
    itemName?: string | undefined;
    jobItemType?: JobItemType;
    serviceTypeGid?: string;
    expectedStartDate?: Date | undefined;
    status?: Status;
    jobItemNumber?: number;
    isFullDay?: boolean;
    purchaseOrderNumber?: string | undefined;
    contactName?: string | undefined;
    contactPhoneNumber?: string | undefined;
    isAdditionalToQuotedProjectScope?: boolean;
    quoteValue?: number;
    suburb?: string | undefined;
    postcode?: string | undefined;
    address?: string | undefined;
    gridReference?: string | undefined;
    locationIdentifier?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    area?: AreaType;
    regionGid?: string;
    scheduledDate?: Date | undefined;
    scheduledTimeRange?: string | undefined;
    estimatedDurationInMinutes?: number;
    estimatedTravelTimeInMinutes?: number;
    assignedToEmployeeGid?: string | undefined;
}

export class JobItemActivityModel implements IJobItemActivityModel {
    gid?: string;
    jobItemGid?: string;
    jobItem?: JobItemModel;
    isDeleted?: boolean;
    activityDateTime?: Date;
    travelTimeInMinutes?: number;
    siteTimeInMinutes?: number;
    notes?: string | undefined;
    employeeGid?: string;
    employee?: EmployeeModel;
    isAdminActivity?: boolean;
    isInvoiced?: boolean;
    invoiceGid?: string | undefined;
    lineItemGid?: string | undefined;
    invoiceType?: ActivityInvoiceType;

    constructor(data?: IJobItemActivityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.jobItemGid = _data["jobItemGid"];
            this.jobItem = _data["jobItem"] ? JobItemModel.fromJS(_data["jobItem"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.activityDateTime = _data["activityDateTime"] ? new Date(_data["activityDateTime"].toString()) : undefined as any;
            this.travelTimeInMinutes = _data["travelTimeInMinutes"];
            this.siteTimeInMinutes = _data["siteTimeInMinutes"];
            this.notes = _data["notes"];
            this.employeeGid = _data["employeeGid"];
            this.employee = _data["employee"] ? EmployeeModel.fromJS(_data["employee"]) : undefined as any;
            this.isAdminActivity = _data["isAdminActivity"];
            this.isInvoiced = _data["isInvoiced"];
            this.invoiceGid = _data["invoiceGid"];
            this.lineItemGid = _data["lineItemGid"];
            this.invoiceType = _data["invoiceType"];
        }
    }

    static fromJS(data: any): JobItemActivityModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobItemActivityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["jobItemGid"] = this.jobItemGid;
        data["jobItem"] = this.jobItem ? this.jobItem.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["activityDateTime"] = this.activityDateTime ? this.activityDateTime.toISOString() : undefined as any;
        data["travelTimeInMinutes"] = this.travelTimeInMinutes;
        data["siteTimeInMinutes"] = this.siteTimeInMinutes;
        data["notes"] = this.notes;
        data["employeeGid"] = this.employeeGid;
        data["employee"] = this.employee ? this.employee.toJSON() : undefined as any;
        data["isAdminActivity"] = this.isAdminActivity;
        data["isInvoiced"] = this.isInvoiced;
        data["invoiceGid"] = this.invoiceGid;
        data["lineItemGid"] = this.lineItemGid;
        data["invoiceType"] = this.invoiceType;
        return data;
    }
}

export interface IJobItemActivityModel {
    gid?: string;
    jobItemGid?: string;
    jobItem?: JobItemModel;
    isDeleted?: boolean;
    activityDateTime?: Date;
    travelTimeInMinutes?: number;
    siteTimeInMinutes?: number;
    notes?: string | undefined;
    employeeGid?: string;
    employee?: EmployeeModel;
    isAdminActivity?: boolean;
    isInvoiced?: boolean;
    invoiceGid?: string | undefined;
    lineItemGid?: string | undefined;
    invoiceType?: ActivityInvoiceType;
}

export class JobItemByNumberSearchResultModel implements IJobItemByNumberSearchResultModel {
    jobGid?: string;
    jobItemGid?: string;
    jobItemNumber?: string | undefined;
    jobItemName?: string | undefined;
    clientName?: string | undefined;
    externalReferenceNumber?: string | undefined;
    jobItemType?: JobItemType;
    status?: Status;

    constructor(data?: IJobItemByNumberSearchResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobGid = _data["jobGid"];
            this.jobItemGid = _data["jobItemGid"];
            this.jobItemNumber = _data["jobItemNumber"];
            this.jobItemName = _data["jobItemName"];
            this.clientName = _data["clientName"];
            this.externalReferenceNumber = _data["externalReferenceNumber"];
            this.jobItemType = _data["jobItemType"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): JobItemByNumberSearchResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobItemByNumberSearchResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobGid"] = this.jobGid;
        data["jobItemGid"] = this.jobItemGid;
        data["jobItemNumber"] = this.jobItemNumber;
        data["jobItemName"] = this.jobItemName;
        data["clientName"] = this.clientName;
        data["externalReferenceNumber"] = this.externalReferenceNumber;
        data["jobItemType"] = this.jobItemType;
        data["status"] = this.status;
        return data;
    }
}

export interface IJobItemByNumberSearchResultModel {
    jobGid?: string;
    jobItemGid?: string;
    jobItemNumber?: string | undefined;
    jobItemName?: string | undefined;
    clientName?: string | undefined;
    externalReferenceNumber?: string | undefined;
    jobItemType?: JobItemType;
    status?: Status;
}

export class JobItemCancelModel implements IJobItemCancelModel {
    gid?: string;
    cancelReason?: string | undefined;
    cancelledByUserGid?: string;

    constructor(data?: IJobItemCancelModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.cancelReason = _data["cancelReason"];
            this.cancelledByUserGid = _data["cancelledByUserGid"];
        }
    }

    static fromJS(data: any): JobItemCancelModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobItemCancelModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["cancelReason"] = this.cancelReason;
        data["cancelledByUserGid"] = this.cancelledByUserGid;
        return data;
    }
}

export interface IJobItemCancelModel {
    gid?: string;
    cancelReason?: string | undefined;
    cancelledByUserGid?: string;
}

export class JobItemModel implements IJobItemModel {
    gid?: string;
    jobGid?: string;
    job?: JobModel;
    name?: string | undefined;
    description?: string | undefined;
    jobItemType?: JobItemType;
    serviceTypeGid?: string;
    serviceType?: ServiceTypeModel;
    expectedStartDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualCompletedDate?: Date | undefined;
    locationGid?: string;
    location?: LocationModel;
    status?: Status;
    jobItemNumber?: number;
    isFullDay?: boolean;
    notes?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    contactName?: string | undefined;
    contactPhoneNumber?: string | undefined;
    quoteValue?: number;
    isAdditionalToQuotedProjectScope?: boolean;
    scheduledDate?: Date | undefined;
    assignedTo?: EmployeeModel;
    orderIndex?: number;

    constructor(data?: IJobItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.jobGid = _data["jobGid"];
            this.job = _data["job"] ? JobModel.fromJS(_data["job"]) : undefined as any;
            this.name = _data["name"];
            this.description = _data["description"];
            this.jobItemType = _data["jobItemType"];
            this.serviceTypeGid = _data["serviceTypeGid"];
            this.serviceType = _data["serviceType"] ? ServiceTypeModel.fromJS(_data["serviceType"]) : undefined as any;
            this.expectedStartDate = _data["expectedStartDate"] ? new Date(_data["expectedStartDate"].toString()) : undefined as any;
            this.actualStartDate = _data["actualStartDate"] ? new Date(_data["actualStartDate"].toString()) : undefined as any;
            this.actualCompletedDate = _data["actualCompletedDate"] ? new Date(_data["actualCompletedDate"].toString()) : undefined as any;
            this.locationGid = _data["locationGid"];
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : undefined as any;
            this.status = _data["status"];
            this.jobItemNumber = _data["jobItemNumber"];
            this.isFullDay = _data["isFullDay"];
            this.notes = _data["notes"];
            this.purchaseOrderNumber = _data["purchaseOrderNumber"];
            this.contactName = _data["contactName"];
            this.contactPhoneNumber = _data["contactPhoneNumber"];
            this.quoteValue = _data["quoteValue"];
            this.isAdditionalToQuotedProjectScope = _data["isAdditionalToQuotedProjectScope"];
            this.scheduledDate = _data["scheduledDate"] ? new Date(_data["scheduledDate"].toString()) : undefined as any;
            this.assignedTo = _data["assignedTo"] ? EmployeeModel.fromJS(_data["assignedTo"]) : undefined as any;
            this.orderIndex = _data["orderIndex"];
        }
    }

    static fromJS(data: any): JobItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["jobGid"] = this.jobGid;
        data["job"] = this.job ? this.job.toJSON() : undefined as any;
        data["name"] = this.name;
        data["description"] = this.description;
        data["jobItemType"] = this.jobItemType;
        data["serviceTypeGid"] = this.serviceTypeGid;
        data["serviceType"] = this.serviceType ? this.serviceType.toJSON() : undefined as any;
        data["expectedStartDate"] = this.expectedStartDate ? this.expectedStartDate.toISOString() : undefined as any;
        data["actualStartDate"] = this.actualStartDate ? this.actualStartDate.toISOString() : undefined as any;
        data["actualCompletedDate"] = this.actualCompletedDate ? this.actualCompletedDate.toISOString() : undefined as any;
        data["locationGid"] = this.locationGid;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["status"] = this.status;
        data["jobItemNumber"] = this.jobItemNumber;
        data["isFullDay"] = this.isFullDay;
        data["notes"] = this.notes;
        data["purchaseOrderNumber"] = this.purchaseOrderNumber;
        data["contactName"] = this.contactName;
        data["contactPhoneNumber"] = this.contactPhoneNumber;
        data["quoteValue"] = this.quoteValue;
        data["isAdditionalToQuotedProjectScope"] = this.isAdditionalToQuotedProjectScope;
        data["scheduledDate"] = this.scheduledDate ? this.scheduledDate.toISOString() : undefined as any;
        data["assignedTo"] = this.assignedTo ? this.assignedTo.toJSON() : undefined as any;
        data["orderIndex"] = this.orderIndex;
        return data;
    }
}

export interface IJobItemModel {
    gid?: string;
    jobGid?: string;
    job?: JobModel;
    name?: string | undefined;
    description?: string | undefined;
    jobItemType?: JobItemType;
    serviceTypeGid?: string;
    serviceType?: ServiceTypeModel;
    expectedStartDate?: Date | undefined;
    actualStartDate?: Date | undefined;
    actualCompletedDate?: Date | undefined;
    locationGid?: string;
    location?: LocationModel;
    status?: Status;
    jobItemNumber?: number;
    isFullDay?: boolean;
    notes?: string | undefined;
    purchaseOrderNumber?: string | undefined;
    contactName?: string | undefined;
    contactPhoneNumber?: string | undefined;
    quoteValue?: number;
    isAdditionalToQuotedProjectScope?: boolean;
    scheduledDate?: Date | undefined;
    assignedTo?: EmployeeModel;
    orderIndex?: number;
}

export class JobItemScheduleAssignEmployeeModel implements IJobItemScheduleAssignEmployeeModel {
    jobItemGid?: string;
    jobItemScheduleGid?: string;
    assignToEmployeeGid?: string;

    constructor(data?: IJobItemScheduleAssignEmployeeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobItemGid = _data["jobItemGid"];
            this.jobItemScheduleGid = _data["jobItemScheduleGid"];
            this.assignToEmployeeGid = _data["assignToEmployeeGid"];
        }
    }

    static fromJS(data: any): JobItemScheduleAssignEmployeeModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobItemScheduleAssignEmployeeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobItemGid"] = this.jobItemGid;
        data["jobItemScheduleGid"] = this.jobItemScheduleGid;
        data["assignToEmployeeGid"] = this.assignToEmployeeGid;
        return data;
    }
}

export interface IJobItemScheduleAssignEmployeeModel {
    jobItemGid?: string;
    jobItemScheduleGid?: string;
    assignToEmployeeGid?: string;
}

export class JobItemScheduleModel implements IJobItemScheduleModel {
    gid?: string;
    isDeleted?: boolean;
    assignedToEmployeeGid?: string | undefined;
    assignedToEmployee?: EmployeeModel;
    scheduledDate?: Date;
    scheduledTimeRange?: string | undefined;
    estimatedDurationInMinutes?: number;
    estimatedTravelTimeInMinutes?: number;
    numberOfLots?: number;
    notes?: string | undefined;

    constructor(data?: IJobItemScheduleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.isDeleted = _data["isDeleted"];
            this.assignedToEmployeeGid = _data["assignedToEmployeeGid"];
            this.assignedToEmployee = _data["assignedToEmployee"] ? EmployeeModel.fromJS(_data["assignedToEmployee"]) : undefined as any;
            this.scheduledDate = _data["scheduledDate"] ? new Date(_data["scheduledDate"].toString()) : undefined as any;
            this.scheduledTimeRange = _data["scheduledTimeRange"];
            this.estimatedDurationInMinutes = _data["estimatedDurationInMinutes"];
            this.estimatedTravelTimeInMinutes = _data["estimatedTravelTimeInMinutes"];
            this.numberOfLots = _data["numberOfLots"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): JobItemScheduleModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobItemScheduleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["isDeleted"] = this.isDeleted;
        data["assignedToEmployeeGid"] = this.assignedToEmployeeGid;
        data["assignedToEmployee"] = this.assignedToEmployee ? this.assignedToEmployee.toJSON() : undefined as any;
        data["scheduledDate"] = this.scheduledDate ? this.scheduledDate.toISOString() : undefined as any;
        data["scheduledTimeRange"] = this.scheduledTimeRange;
        data["estimatedDurationInMinutes"] = this.estimatedDurationInMinutes;
        data["estimatedTravelTimeInMinutes"] = this.estimatedTravelTimeInMinutes;
        data["numberOfLots"] = this.numberOfLots;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IJobItemScheduleModel {
    gid?: string;
    isDeleted?: boolean;
    assignedToEmployeeGid?: string | undefined;
    assignedToEmployee?: EmployeeModel;
    scheduledDate?: Date;
    scheduledTimeRange?: string | undefined;
    estimatedDurationInMinutes?: number;
    estimatedTravelTimeInMinutes?: number;
    numberOfLots?: number;
    notes?: string | undefined;
}

export class JobItemScheduleSequenceModel implements IJobItemScheduleSequenceModel {
    gid?: string;
    orderIndex?: number;

    constructor(data?: IJobItemScheduleSequenceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.orderIndex = _data["orderIndex"];
        }
    }

    static fromJS(data: any): JobItemScheduleSequenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobItemScheduleSequenceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["orderIndex"] = this.orderIndex;
        return data;
    }
}

export interface IJobItemScheduleSequenceModel {
    gid?: string;
    orderIndex?: number;
}

export enum JobItemType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
}

export class JobItemUpdateScheduleModel implements IJobItemUpdateScheduleModel {
    jobItemGid?: string;
    jobItemScheduleGid?: string | undefined;
    scheduledDateISO?: number;
    estimatedTravelTimeInMinutes?: number;
    estimatedDurationInMinutes?: number;
    scheduledTimeRange?: string | undefined;
    notes?: string | undefined;
    assignedToEmployeeGid?: string | undefined;

    constructor(data?: IJobItemUpdateScheduleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobItemGid = _data["jobItemGid"];
            this.jobItemScheduleGid = _data["jobItemScheduleGid"];
            this.scheduledDateISO = _data["scheduledDateISO"];
            this.estimatedTravelTimeInMinutes = _data["estimatedTravelTimeInMinutes"];
            this.estimatedDurationInMinutes = _data["estimatedDurationInMinutes"];
            this.scheduledTimeRange = _data["scheduledTimeRange"];
            this.notes = _data["notes"];
            this.assignedToEmployeeGid = _data["assignedToEmployeeGid"];
        }
    }

    static fromJS(data: any): JobItemUpdateScheduleModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobItemUpdateScheduleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobItemGid"] = this.jobItemGid;
        data["jobItemScheduleGid"] = this.jobItemScheduleGid;
        data["scheduledDateISO"] = this.scheduledDateISO;
        data["estimatedTravelTimeInMinutes"] = this.estimatedTravelTimeInMinutes;
        data["estimatedDurationInMinutes"] = this.estimatedDurationInMinutes;
        data["scheduledTimeRange"] = this.scheduledTimeRange;
        data["notes"] = this.notes;
        data["assignedToEmployeeGid"] = this.assignedToEmployeeGid;
        return data;
    }
}

export interface IJobItemUpdateScheduleModel {
    jobItemGid?: string;
    jobItemScheduleGid?: string | undefined;
    scheduledDateISO?: number;
    estimatedTravelTimeInMinutes?: number;
    estimatedDurationInMinutes?: number;
    scheduledTimeRange?: string | undefined;
    notes?: string | undefined;
    assignedToEmployeeGid?: string | undefined;
}

export class JobModel implements IJobModel {
    gid?: string;
    name!: string;
    network?: NetworkModel;
    networkGid!: string;
    client?: ClientModel;
    clientGid!: string;
    jobNumber?: string | undefined;
    workOrderNumber?: string | undefined;
    externalReferenceNumber?: string | undefined;
    jobType?: JobType;
    initiatorName?: string | undefined;
    initiatorPhoneNumber?: string | undefined;
    siteContactName?: string | undefined;
    siteContactPhoneNumber?: string | undefined;
    projectDescription?: string | undefined;
    isQuotedProject?: boolean;

    constructor(data?: IJobModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            this.network = _data["network"] ? NetworkModel.fromJS(_data["network"]) : undefined as any;
            this.networkGid = _data["networkGid"];
            this.client = _data["client"] ? ClientModel.fromJS(_data["client"]) : undefined as any;
            this.clientGid = _data["clientGid"];
            this.jobNumber = _data["jobNumber"];
            this.workOrderNumber = _data["workOrderNumber"];
            this.externalReferenceNumber = _data["externalReferenceNumber"];
            this.jobType = _data["jobType"];
            this.initiatorName = _data["initiatorName"];
            this.initiatorPhoneNumber = _data["initiatorPhoneNumber"];
            this.siteContactName = _data["siteContactName"];
            this.siteContactPhoneNumber = _data["siteContactPhoneNumber"];
            this.projectDescription = _data["projectDescription"];
            this.isQuotedProject = _data["isQuotedProject"];
        }
    }

    static fromJS(data: any): JobModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        data["network"] = this.network ? this.network.toJSON() : undefined as any;
        data["networkGid"] = this.networkGid;
        data["client"] = this.client ? this.client.toJSON() : undefined as any;
        data["clientGid"] = this.clientGid;
        data["jobNumber"] = this.jobNumber;
        data["workOrderNumber"] = this.workOrderNumber;
        data["externalReferenceNumber"] = this.externalReferenceNumber;
        data["jobType"] = this.jobType;
        data["initiatorName"] = this.initiatorName;
        data["initiatorPhoneNumber"] = this.initiatorPhoneNumber;
        data["siteContactName"] = this.siteContactName;
        data["siteContactPhoneNumber"] = this.siteContactPhoneNumber;
        data["projectDescription"] = this.projectDescription;
        data["isQuotedProject"] = this.isQuotedProject;
        return data;
    }
}

export interface IJobModel {
    gid?: string;
    name: string;
    network?: NetworkModel;
    networkGid: string;
    client?: ClientModel;
    clientGid: string;
    jobNumber?: string | undefined;
    workOrderNumber?: string | undefined;
    externalReferenceNumber?: string | undefined;
    jobType?: JobType;
    initiatorName?: string | undefined;
    initiatorPhoneNumber?: string | undefined;
    siteContactName?: string | undefined;
    siteContactPhoneNumber?: string | undefined;
    projectDescription?: string | undefined;
    isQuotedProject?: boolean;
}

export class JobNoteModel implements IJobNoteModel {
    gid?: string;
    jobGid?: string;
    job?: JobModel;
    jobItemGid?: string | undefined;
    jobItem?: JobItemModel;
    isDeleted?: boolean;
    createdDateTime?: Date;
    notes?: string | undefined;
    createdByUserGid?: string;
    createdByUser?: UserModel;

    constructor(data?: IJobNoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.jobGid = _data["jobGid"];
            this.job = _data["job"] ? JobModel.fromJS(_data["job"]) : undefined as any;
            this.jobItemGid = _data["jobItemGid"];
            this.jobItem = _data["jobItem"] ? JobItemModel.fromJS(_data["jobItem"]) : undefined as any;
            this.isDeleted = _data["isDeleted"];
            this.createdDateTime = _data["createdDateTime"] ? new Date(_data["createdDateTime"].toString()) : undefined as any;
            this.notes = _data["notes"];
            this.createdByUserGid = _data["createdByUserGid"];
            this.createdByUser = _data["createdByUser"] ? UserModel.fromJS(_data["createdByUser"]) : undefined as any;
        }
    }

    static fromJS(data: any): JobNoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobNoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["jobGid"] = this.jobGid;
        data["job"] = this.job ? this.job.toJSON() : undefined as any;
        data["jobItemGid"] = this.jobItemGid;
        data["jobItem"] = this.jobItem ? this.jobItem.toJSON() : undefined as any;
        data["isDeleted"] = this.isDeleted;
        data["createdDateTime"] = this.createdDateTime ? this.createdDateTime.toISOString() : undefined as any;
        data["notes"] = this.notes;
        data["createdByUserGid"] = this.createdByUserGid;
        data["createdByUser"] = this.createdByUser ? this.createdByUser.toJSON() : undefined as any;
        return data;
    }
}

export interface IJobNoteModel {
    gid?: string;
    jobGid?: string;
    job?: JobModel;
    jobItemGid?: string | undefined;
    jobItem?: JobItemModel;
    isDeleted?: boolean;
    createdDateTime?: Date;
    notes?: string | undefined;
    createdByUserGid?: string;
    createdByUser?: UserModel;
}

export class JobNumberModel implements IJobNumberModel {
    number?: number;

    constructor(data?: IJobNumberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): JobNumberModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobNumberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        return data;
    }
}

export interface IJobNumberModel {
    number?: number;
}

export class JobSearchResultModel implements IJobSearchResultModel {
    gid?: string;
    name?: string | undefined;
    client?: string | undefined;
    jobNumber?: string | undefined;
    workOrderNumber?: string | undefined;
    externalReferenceNumber?: string | undefined;
    siteContactName?: string | undefined;
    itemName?: string | undefined;
    network?: string | undefined;
    jobItemType?: JobItemType;
    status?: Status;
    address?: string | undefined;
    suburb?: string | undefined;
    postcode?: string | undefined;
    lastJobItemDate?: Date | undefined;
    nextJobItemDate?: Date | undefined;

    constructor(data?: IJobSearchResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            this.client = _data["client"];
            this.jobNumber = _data["jobNumber"];
            this.workOrderNumber = _data["workOrderNumber"];
            this.externalReferenceNumber = _data["externalReferenceNumber"];
            this.siteContactName = _data["siteContactName"];
            this.itemName = _data["itemName"];
            this.network = _data["network"];
            this.jobItemType = _data["jobItemType"];
            this.status = _data["status"];
            this.address = _data["address"];
            this.suburb = _data["suburb"];
            this.postcode = _data["postcode"];
            this.lastJobItemDate = _data["lastJobItemDate"] ? new Date(_data["lastJobItemDate"].toString()) : undefined as any;
            this.nextJobItemDate = _data["nextJobItemDate"] ? new Date(_data["nextJobItemDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): JobSearchResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new JobSearchResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        data["client"] = this.client;
        data["jobNumber"] = this.jobNumber;
        data["workOrderNumber"] = this.workOrderNumber;
        data["externalReferenceNumber"] = this.externalReferenceNumber;
        data["siteContactName"] = this.siteContactName;
        data["itemName"] = this.itemName;
        data["network"] = this.network;
        data["jobItemType"] = this.jobItemType;
        data["status"] = this.status;
        data["address"] = this.address;
        data["suburb"] = this.suburb;
        data["postcode"] = this.postcode;
        data["lastJobItemDate"] = this.lastJobItemDate ? this.lastJobItemDate.toISOString() : undefined as any;
        data["nextJobItemDate"] = this.nextJobItemDate ? this.nextJobItemDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IJobSearchResultModel {
    gid?: string;
    name?: string | undefined;
    client?: string | undefined;
    jobNumber?: string | undefined;
    workOrderNumber?: string | undefined;
    externalReferenceNumber?: string | undefined;
    siteContactName?: string | undefined;
    itemName?: string | undefined;
    network?: string | undefined;
    jobItemType?: JobItemType;
    status?: Status;
    address?: string | undefined;
    suburb?: string | undefined;
    postcode?: string | undefined;
    lastJobItemDate?: Date | undefined;
    nextJobItemDate?: Date | undefined;
}

export enum JobType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
}

export class LineItemModel implements ILineItemModel {
    gid?: string;
    isDeleted?: boolean;
    invoiceGid?: string;
    accountCode?: string | undefined;
    amountUnit?: number;
    quantity?: number;
    description?: string | undefined;
    comment?: string | undefined;
    amountExTax?: number;
    amountTax?: number;
    amountIncTax?: number;

    constructor(data?: ILineItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.isDeleted = _data["isDeleted"];
            this.invoiceGid = _data["invoiceGid"];
            this.accountCode = _data["accountCode"];
            this.amountUnit = _data["amountUnit"];
            this.quantity = _data["quantity"];
            this.description = _data["description"];
            this.comment = _data["comment"];
            this.amountExTax = _data["amountExTax"];
            this.amountTax = _data["amountTax"];
            this.amountIncTax = _data["amountIncTax"];
        }
    }

    static fromJS(data: any): LineItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new LineItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["isDeleted"] = this.isDeleted;
        data["invoiceGid"] = this.invoiceGid;
        data["accountCode"] = this.accountCode;
        data["amountUnit"] = this.amountUnit;
        data["quantity"] = this.quantity;
        data["description"] = this.description;
        data["comment"] = this.comment;
        data["amountExTax"] = this.amountExTax;
        data["amountTax"] = this.amountTax;
        data["amountIncTax"] = this.amountIncTax;
        return data;
    }
}

export interface ILineItemModel {
    gid?: string;
    isDeleted?: boolean;
    invoiceGid?: string;
    accountCode?: string | undefined;
    amountUnit?: number;
    quantity?: number;
    description?: string | undefined;
    comment?: string | undefined;
    amountExTax?: number;
    amountTax?: number;
    amountIncTax?: number;
}

export class LocationModel implements ILocationModel {
    gid?: string;
    suburb?: string | undefined;
    postcode?: string | undefined;
    address?: string | undefined;
    gridReference?: string | undefined;
    locationIdentifier?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    area?: AreaType;

    constructor(data?: ILocationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.suburb = _data["suburb"];
            this.postcode = _data["postcode"];
            this.address = _data["address"];
            this.gridReference = _data["gridReference"];
            this.locationIdentifier = _data["locationIdentifier"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.area = _data["area"];
        }
    }

    static fromJS(data: any): LocationModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["suburb"] = this.suburb;
        data["postcode"] = this.postcode;
        data["address"] = this.address;
        data["gridReference"] = this.gridReference;
        data["locationIdentifier"] = this.locationIdentifier;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["area"] = this.area;
        return data;
    }
}

export interface ILocationModel {
    gid?: string;
    suburb?: string | undefined;
    postcode?: string | undefined;
    address?: string | undefined;
    gridReference?: string | undefined;
    locationIdentifier?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    area?: AreaType;
}

export enum MessageLevel {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class MissedInvoiceJobItemModel implements IMissedInvoiceJobItemModel {
    jobGid?: string;
    jobItemGid?: string;
    jobItemNumber?: string | undefined;
    jobName?: string | undefined;
    clientName?: string | undefined;
    jobItemName?: string | undefined;
    status?: Status;
    jobItemType?: JobItemType;
    scheduledDate?: Date | undefined;
    assignedTo?: string | undefined;

    constructor(data?: IMissedInvoiceJobItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobGid = _data["jobGid"];
            this.jobItemGid = _data["jobItemGid"];
            this.jobItemNumber = _data["jobItemNumber"];
            this.jobName = _data["jobName"];
            this.clientName = _data["clientName"];
            this.jobItemName = _data["jobItemName"];
            this.status = _data["status"];
            this.jobItemType = _data["jobItemType"];
            this.scheduledDate = _data["scheduledDate"] ? new Date(_data["scheduledDate"].toString()) : undefined as any;
            this.assignedTo = _data["assignedTo"];
        }
    }

    static fromJS(data: any): MissedInvoiceJobItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new MissedInvoiceJobItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobGid"] = this.jobGid;
        data["jobItemGid"] = this.jobItemGid;
        data["jobItemNumber"] = this.jobItemNumber;
        data["jobName"] = this.jobName;
        data["clientName"] = this.clientName;
        data["jobItemName"] = this.jobItemName;
        data["status"] = this.status;
        data["jobItemType"] = this.jobItemType;
        data["scheduledDate"] = this.scheduledDate ? this.scheduledDate.toISOString() : undefined as any;
        data["assignedTo"] = this.assignedTo;
        return data;
    }
}

export interface IMissedInvoiceJobItemModel {
    jobGid?: string;
    jobItemGid?: string;
    jobItemNumber?: string | undefined;
    jobName?: string | undefined;
    clientName?: string | undefined;
    jobItemName?: string | undefined;
    status?: Status;
    jobItemType?: JobItemType;
    scheduledDate?: Date | undefined;
    assignedTo?: string | undefined;
}

export class NetworkModel implements INetworkModel {
    gid?: string;
    isDeleted?: boolean;
    name?: string | undefined;
    code?: string | undefined;
    hexColor?: string | undefined;

    constructor(data?: INetworkModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.hexColor = _data["hexColor"];
        }
    }

    static fromJS(data: any): NetworkModel {
        data = typeof data === 'object' ? data : {};
        let result = new NetworkModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["code"] = this.code;
        data["hexColor"] = this.hexColor;
        return data;
    }
}

export interface INetworkModel {
    gid?: string;
    isDeleted?: boolean;
    name?: string | undefined;
    code?: string | undefined;
    hexColor?: string | undefined;
}

export class PostJobItemBulkUpdateRequest implements IPostJobItemBulkUpdateRequest {
    jobItemGids?: string[] | undefined;
    properties?: { [key: string]: string; } | undefined;

    constructor(data?: IPostJobItemBulkUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["jobItemGids"])) {
                this.jobItemGids = [] as any;
                for (let item of _data["jobItemGids"])
                    this.jobItemGids!.push(item);
            }
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (this.properties as any)![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): PostJobItemBulkUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostJobItemBulkUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.jobItemGids)) {
            data["jobItemGids"] = [];
            for (let item of this.jobItemGids)
                data["jobItemGids"].push(item);
        }
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (data["properties"] as any)[key] = (this.properties as any)[key];
            }
        }
        return data;
    }
}

export interface IPostJobItemBulkUpdateRequest {
    jobItemGids?: string[] | undefined;
    properties?: { [key: string]: string; } | undefined;
}

export class PostcodeModel implements IPostcodeModel {
    postcode?: number;
    suburb?: string | undefined;
    state?: string | undefined;
    latitude?: number;
    longitude?: number;

    constructor(data?: IPostcodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postcode = _data["postcode"];
            this.suburb = _data["suburb"];
            this.state = _data["state"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): PostcodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostcodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postcode"] = this.postcode;
        data["suburb"] = this.suburb;
        data["state"] = this.state;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface IPostcodeModel {
    postcode?: number;
    suburb?: string | undefined;
    state?: string | undefined;
    latitude?: number;
    longitude?: number;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class RequestResetPasswordModel implements IRequestResetPasswordModel {
    /** Email Address */
    emailAddress!: string;

    constructor(data?: IRequestResetPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): RequestResetPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResetPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface IRequestResetPasswordModel {
    /** Email Address */
    emailAddress: string;
}

export class ResetPasswordResultErrorModel implements IResetPasswordResultErrorModel {
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IResetPasswordResultErrorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ResetPasswordResultErrorModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResultErrorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IResetPasswordResultErrorModel {
    code?: string | undefined;
    description?: string | undefined;
}

export class ResetPasswordResultModel implements IResetPasswordResultModel {
    succeeded?: boolean;
    errors?: ResetPasswordResultErrorModel[] | undefined;

    constructor(data?: IResetPasswordResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ResetPasswordResultErrorModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ResetPasswordResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IResetPasswordResultModel {
    succeeded?: boolean;
    errors?: ResetPasswordResultErrorModel[] | undefined;
}

export class ScheduledJobItemModel implements IScheduledJobItemModel {
    jobGid?: string;
    jobItemGid?: string;
    jobItemScheduleGid?: string;
    name?: string | undefined;
    networkGid?: string;
    network?: NetworkModel;
    itemName?: string | undefined;
    jobItemType?: JobItemType;
    serviceTypeGid?: string;
    serviceType?: ServiceTypeModel;
    expectedStartDate?: Date | undefined;
    locationGid?: string | undefined;
    location?: LocationModel;
    status?: Status;
    isReinspection?: boolean;
    assignedToEmployeeGid?: string | undefined;
    assignedToEmployee?: string | undefined;
    scheduledDate?: Date;
    scheduledTimeRange?: string | undefined;
    notes?: string | undefined;
    orderIndex?: number;

    constructor(data?: IScheduledJobItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobGid = _data["jobGid"];
            this.jobItemGid = _data["jobItemGid"];
            this.jobItemScheduleGid = _data["jobItemScheduleGid"];
            this.name = _data["name"];
            this.networkGid = _data["networkGid"];
            this.network = _data["network"] ? NetworkModel.fromJS(_data["network"]) : undefined as any;
            this.itemName = _data["itemName"];
            this.jobItemType = _data["jobItemType"];
            this.serviceTypeGid = _data["serviceTypeGid"];
            this.serviceType = _data["serviceType"] ? ServiceTypeModel.fromJS(_data["serviceType"]) : undefined as any;
            this.expectedStartDate = _data["expectedStartDate"] ? new Date(_data["expectedStartDate"].toString()) : undefined as any;
            this.locationGid = _data["locationGid"];
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : undefined as any;
            this.status = _data["status"];
            this.isReinspection = _data["isReinspection"];
            this.assignedToEmployeeGid = _data["assignedToEmployeeGid"];
            this.assignedToEmployee = _data["assignedToEmployee"];
            this.scheduledDate = _data["scheduledDate"] ? new Date(_data["scheduledDate"].toString()) : undefined as any;
            this.scheduledTimeRange = _data["scheduledTimeRange"];
            this.notes = _data["notes"];
            this.orderIndex = _data["orderIndex"];
        }
    }

    static fromJS(data: any): ScheduledJobItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledJobItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobGid"] = this.jobGid;
        data["jobItemGid"] = this.jobItemGid;
        data["jobItemScheduleGid"] = this.jobItemScheduleGid;
        data["name"] = this.name;
        data["networkGid"] = this.networkGid;
        data["network"] = this.network ? this.network.toJSON() : undefined as any;
        data["itemName"] = this.itemName;
        data["jobItemType"] = this.jobItemType;
        data["serviceTypeGid"] = this.serviceTypeGid;
        data["serviceType"] = this.serviceType ? this.serviceType.toJSON() : undefined as any;
        data["expectedStartDate"] = this.expectedStartDate ? this.expectedStartDate.toISOString() : undefined as any;
        data["locationGid"] = this.locationGid;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["status"] = this.status;
        data["isReinspection"] = this.isReinspection;
        data["assignedToEmployeeGid"] = this.assignedToEmployeeGid;
        data["assignedToEmployee"] = this.assignedToEmployee;
        data["scheduledDate"] = this.scheduledDate ? this.scheduledDate.toISOString() : undefined as any;
        data["scheduledTimeRange"] = this.scheduledTimeRange;
        data["notes"] = this.notes;
        data["orderIndex"] = this.orderIndex;
        return data;
    }
}

export interface IScheduledJobItemModel {
    jobGid?: string;
    jobItemGid?: string;
    jobItemScheduleGid?: string;
    name?: string | undefined;
    networkGid?: string;
    network?: NetworkModel;
    itemName?: string | undefined;
    jobItemType?: JobItemType;
    serviceTypeGid?: string;
    serviceType?: ServiceTypeModel;
    expectedStartDate?: Date | undefined;
    locationGid?: string | undefined;
    location?: LocationModel;
    status?: Status;
    isReinspection?: boolean;
    assignedToEmployeeGid?: string | undefined;
    assignedToEmployee?: string | undefined;
    scheduledDate?: Date;
    scheduledTimeRange?: string | undefined;
    notes?: string | undefined;
    orderIndex?: number;
}

export class ServiceTypeCreateModel implements IServiceTypeCreateModel {
    gid?: string;
    isDeleted?: boolean;
    name?: string | undefined;
    baseRate?: number;
    isUnitRate?: boolean;
    parentJobType?: JobItemType;
    accountCode?: string | undefined;
    description?: string | undefined;

    constructor(data?: IServiceTypeCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.baseRate = _data["baseRate"];
            this.isUnitRate = _data["isUnitRate"];
            this.parentJobType = _data["parentJobType"];
            this.accountCode = _data["accountCode"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ServiceTypeCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["baseRate"] = this.baseRate;
        data["isUnitRate"] = this.isUnitRate;
        data["parentJobType"] = this.parentJobType;
        data["accountCode"] = this.accountCode;
        data["description"] = this.description;
        return data;
    }
}

export interface IServiceTypeCreateModel {
    gid?: string;
    isDeleted?: boolean;
    name?: string | undefined;
    baseRate?: number;
    isUnitRate?: boolean;
    parentJobType?: JobItemType;
    accountCode?: string | undefined;
    description?: string | undefined;
}

export class ServiceTypeModel implements IServiceTypeModel {
    gid?: string;
    isDeleted?: boolean;
    name?: string | undefined;
    baseRate?: number;
    isUnitRate?: boolean;
    parentJobType?: JobItemType;
    accountCode?: string | undefined;
    description?: string | undefined;

    constructor(data?: IServiceTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.baseRate = _data["baseRate"];
            this.isUnitRate = _data["isUnitRate"];
            this.parentJobType = _data["parentJobType"];
            this.accountCode = _data["accountCode"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ServiceTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["baseRate"] = this.baseRate;
        data["isUnitRate"] = this.isUnitRate;
        data["parentJobType"] = this.parentJobType;
        data["accountCode"] = this.accountCode;
        data["description"] = this.description;
        return data;
    }
}

export interface IServiceTypeModel {
    gid?: string;
    isDeleted?: boolean;
    name?: string | undefined;
    baseRate?: number;
    isUnitRate?: boolean;
    parentJobType?: JobItemType;
    accountCode?: string | undefined;
    description?: string | undefined;
}

export class ServiceTypeUpdateModel implements IServiceTypeUpdateModel {
    gid?: string;
    isDeleted?: boolean;
    name?: string | undefined;
    baseRate?: number;
    isUnitRate?: boolean;
    parentJobType?: JobItemType;
    accountCode?: string | undefined;
    description?: string | undefined;

    constructor(data?: IServiceTypeUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.isDeleted = _data["isDeleted"];
            this.name = _data["name"];
            this.baseRate = _data["baseRate"];
            this.isUnitRate = _data["isUnitRate"];
            this.parentJobType = _data["parentJobType"];
            this.accountCode = _data["accountCode"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ServiceTypeUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTypeUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["isDeleted"] = this.isDeleted;
        data["name"] = this.name;
        data["baseRate"] = this.baseRate;
        data["isUnitRate"] = this.isUnitRate;
        data["parentJobType"] = this.parentJobType;
        data["accountCode"] = this.accountCode;
        data["description"] = this.description;
        return data;
    }
}

export interface IServiceTypeUpdateModel {
    gid?: string;
    isDeleted?: boolean;
    name?: string | undefined;
    baseRate?: number;
    isUnitRate?: boolean;
    parentJobType?: JobItemType;
    accountCode?: string | undefined;
    description?: string | undefined;
}

export enum Status {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
}

export class TravelTimeCreateModel implements ITravelTimeCreateModel {
    postcode?: string | undefined;
    locality?: string | undefined;
    areaType?: AreaType;
    timeInMinutes?: number;

    constructor(data?: ITravelTimeCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postcode = _data["postcode"];
            this.locality = _data["locality"];
            this.areaType = _data["areaType"];
            this.timeInMinutes = _data["timeInMinutes"];
        }
    }

    static fromJS(data: any): TravelTimeCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TravelTimeCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postcode"] = this.postcode;
        data["locality"] = this.locality;
        data["areaType"] = this.areaType;
        data["timeInMinutes"] = this.timeInMinutes;
        return data;
    }
}

export interface ITravelTimeCreateModel {
    postcode?: string | undefined;
    locality?: string | undefined;
    areaType?: AreaType;
    timeInMinutes?: number;
}

export class TravelTimeModel implements ITravelTimeModel {
    gid?: string;
    isDeleted?: boolean;
    postcode?: string | undefined;
    locality?: string | undefined;
    areaType?: AreaType;
    timeInMinutes?: number;

    constructor(data?: ITravelTimeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.isDeleted = _data["isDeleted"];
            this.postcode = _data["postcode"];
            this.locality = _data["locality"];
            this.areaType = _data["areaType"];
            this.timeInMinutes = _data["timeInMinutes"];
        }
    }

    static fromJS(data: any): TravelTimeModel {
        data = typeof data === 'object' ? data : {};
        let result = new TravelTimeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["isDeleted"] = this.isDeleted;
        data["postcode"] = this.postcode;
        data["locality"] = this.locality;
        data["areaType"] = this.areaType;
        data["timeInMinutes"] = this.timeInMinutes;
        return data;
    }
}

export interface ITravelTimeModel {
    gid?: string;
    isDeleted?: boolean;
    postcode?: string | undefined;
    locality?: string | undefined;
    areaType?: AreaType;
    timeInMinutes?: number;
}

export class TravelTimeUpdateModel implements ITravelTimeUpdateModel {
    gid?: string;
    postcode?: string | undefined;
    locality?: string | undefined;
    areaType?: AreaType;
    timeInMinutes?: number;

    constructor(data?: ITravelTimeUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.postcode = _data["postcode"];
            this.locality = _data["locality"];
            this.areaType = _data["areaType"];
            this.timeInMinutes = _data["timeInMinutes"];
        }
    }

    static fromJS(data: any): TravelTimeUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TravelTimeUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["postcode"] = this.postcode;
        data["locality"] = this.locality;
        data["areaType"] = this.areaType;
        data["timeInMinutes"] = this.timeInMinutes;
        return data;
    }
}

export interface ITravelTimeUpdateModel {
    gid?: string;
    postcode?: string | undefined;
    locality?: string | undefined;
    areaType?: AreaType;
    timeInMinutes?: number;
}

export class UnscheduledJobItemModel implements IUnscheduledJobItemModel {
    jobGid?: string;
    jobItemGid?: string;
    name?: string | undefined;
    networkGid?: string;
    network?: NetworkModel;
    itemName?: string | undefined;
    jobItemType?: JobItemType;
    serviceTypeGid?: string;
    serviceType?: ServiceTypeModel;
    expectedStartDate?: Date | undefined;
    locationGid?: string | undefined;
    location?: LocationModel;
    status?: Status;
    isReinspection?: boolean;

    constructor(data?: IUnscheduledJobItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobGid = _data["jobGid"];
            this.jobItemGid = _data["jobItemGid"];
            this.name = _data["name"];
            this.networkGid = _data["networkGid"];
            this.network = _data["network"] ? NetworkModel.fromJS(_data["network"]) : undefined as any;
            this.itemName = _data["itemName"];
            this.jobItemType = _data["jobItemType"];
            this.serviceTypeGid = _data["serviceTypeGid"];
            this.serviceType = _data["serviceType"] ? ServiceTypeModel.fromJS(_data["serviceType"]) : undefined as any;
            this.expectedStartDate = _data["expectedStartDate"] ? new Date(_data["expectedStartDate"].toString()) : undefined as any;
            this.locationGid = _data["locationGid"];
            this.location = _data["location"] ? LocationModel.fromJS(_data["location"]) : undefined as any;
            this.status = _data["status"];
            this.isReinspection = _data["isReinspection"];
        }
    }

    static fromJS(data: any): UnscheduledJobItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new UnscheduledJobItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobGid"] = this.jobGid;
        data["jobItemGid"] = this.jobItemGid;
        data["name"] = this.name;
        data["networkGid"] = this.networkGid;
        data["network"] = this.network ? this.network.toJSON() : undefined as any;
        data["itemName"] = this.itemName;
        data["jobItemType"] = this.jobItemType;
        data["serviceTypeGid"] = this.serviceTypeGid;
        data["serviceType"] = this.serviceType ? this.serviceType.toJSON() : undefined as any;
        data["expectedStartDate"] = this.expectedStartDate ? this.expectedStartDate.toISOString() : undefined as any;
        data["locationGid"] = this.locationGid;
        data["location"] = this.location ? this.location.toJSON() : undefined as any;
        data["status"] = this.status;
        data["isReinspection"] = this.isReinspection;
        return data;
    }
}

export interface IUnscheduledJobItemModel {
    jobGid?: string;
    jobItemGid?: string;
    name?: string | undefined;
    networkGid?: string;
    network?: NetworkModel;
    itemName?: string | undefined;
    jobItemType?: JobItemType;
    serviceTypeGid?: string;
    serviceType?: ServiceTypeModel;
    expectedStartDate?: Date | undefined;
    locationGid?: string | undefined;
    location?: LocationModel;
    status?: Status;
    isReinspection?: boolean;
}

export class UpdateInvoiceBatchRequestModel implements IUpdateInvoiceBatchRequestModel {
    gid?: string;
    isDeleted?: boolean;
    batchName?: string | undefined;
    clientGid?: string | undefined;
    openDateTimeUtc?: Date;
    closedDateTimeUtc?: Date | undefined;
    defaultInvoiceDate?: Date;
    useActivityDateAsInvoiceDate?: boolean;

    constructor(data?: IUpdateInvoiceBatchRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.isDeleted = _data["isDeleted"];
            this.batchName = _data["batchName"];
            this.clientGid = _data["clientGid"];
            this.openDateTimeUtc = _data["openDateTimeUtc"] ? new Date(_data["openDateTimeUtc"].toString()) : undefined as any;
            this.closedDateTimeUtc = _data["closedDateTimeUtc"] ? new Date(_data["closedDateTimeUtc"].toString()) : undefined as any;
            this.defaultInvoiceDate = _data["defaultInvoiceDate"] ? new Date(_data["defaultInvoiceDate"].toString()) : undefined as any;
            this.useActivityDateAsInvoiceDate = _data["useActivityDateAsInvoiceDate"];
        }
    }

    static fromJS(data: any): UpdateInvoiceBatchRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceBatchRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["isDeleted"] = this.isDeleted;
        data["batchName"] = this.batchName;
        data["clientGid"] = this.clientGid;
        data["openDateTimeUtc"] = this.openDateTimeUtc ? this.openDateTimeUtc.toISOString() : undefined as any;
        data["closedDateTimeUtc"] = this.closedDateTimeUtc ? this.closedDateTimeUtc.toISOString() : undefined as any;
        data["defaultInvoiceDate"] = this.defaultInvoiceDate ? this.defaultInvoiceDate.toISOString() : undefined as any;
        data["useActivityDateAsInvoiceDate"] = this.useActivityDateAsInvoiceDate;
        return data;
    }
}

export interface IUpdateInvoiceBatchRequestModel {
    gid?: string;
    isDeleted?: boolean;
    batchName?: string | undefined;
    clientGid?: string | undefined;
    openDateTimeUtc?: Date;
    closedDateTimeUtc?: Date | undefined;
    defaultInvoiceDate?: Date;
    useActivityDateAsInvoiceDate?: boolean;
}

export class UpdateInvoiceRequestLineItemModel implements IUpdateInvoiceRequestLineItemModel {
    gid?: string;
    accountCode?: string | undefined;
    amountUnit?: number;
    quantity?: number;
    description?: string | undefined;
    comment?: string | undefined;
    amountExTax?: number;
    amountTax?: number;
    amountIncTax?: number;
    jobItemActivityGids?: string[] | undefined;

    constructor(data?: IUpdateInvoiceRequestLineItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.accountCode = _data["accountCode"];
            this.amountUnit = _data["amountUnit"];
            this.quantity = _data["quantity"];
            this.description = _data["description"];
            this.comment = _data["comment"];
            this.amountExTax = _data["amountExTax"];
            this.amountTax = _data["amountTax"];
            this.amountIncTax = _data["amountIncTax"];
            if (Array.isArray(_data["jobItemActivityGids"])) {
                this.jobItemActivityGids = [] as any;
                for (let item of _data["jobItemActivityGids"])
                    this.jobItemActivityGids!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateInvoiceRequestLineItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceRequestLineItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["accountCode"] = this.accountCode;
        data["amountUnit"] = this.amountUnit;
        data["quantity"] = this.quantity;
        data["description"] = this.description;
        data["comment"] = this.comment;
        data["amountExTax"] = this.amountExTax;
        data["amountTax"] = this.amountTax;
        data["amountIncTax"] = this.amountIncTax;
        if (Array.isArray(this.jobItemActivityGids)) {
            data["jobItemActivityGids"] = [];
            for (let item of this.jobItemActivityGids)
                data["jobItemActivityGids"].push(item);
        }
        return data;
    }
}

export interface IUpdateInvoiceRequestLineItemModel {
    gid?: string;
    accountCode?: string | undefined;
    amountUnit?: number;
    quantity?: number;
    description?: string | undefined;
    comment?: string | undefined;
    amountExTax?: number;
    amountTax?: number;
    amountIncTax?: number;
    jobItemActivityGids?: string[] | undefined;
}

export class UpdateInvoiceRequestModel implements IUpdateInvoiceRequestModel {
    gid?: string;
    invoiceBatchGid?: string | undefined;
    clientGid?: string;
    jobGid?: string;
    invoiceDate?: Date;
    amountExTax?: number;
    amountTax?: number;
    amountIncTax?: number;
    paid?: boolean;
    amountPaid?: number;
    lineItems?: UpdateInvoiceRequestLineItemModel[] | undefined;

    constructor(data?: IUpdateInvoiceRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.invoiceBatchGid = _data["invoiceBatchGid"];
            this.clientGid = _data["clientGid"];
            this.jobGid = _data["jobGid"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.amountExTax = _data["amountExTax"];
            this.amountTax = _data["amountTax"];
            this.amountIncTax = _data["amountIncTax"];
            this.paid = _data["paid"];
            this.amountPaid = _data["amountPaid"];
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(UpdateInvoiceRequestLineItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateInvoiceRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInvoiceRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["invoiceBatchGid"] = this.invoiceBatchGid;
        data["clientGid"] = this.clientGid;
        data["jobGid"] = this.jobGid;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["amountExTax"] = this.amountExTax;
        data["amountTax"] = this.amountTax;
        data["amountIncTax"] = this.amountIncTax;
        data["paid"] = this.paid;
        data["amountPaid"] = this.amountPaid;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUpdateInvoiceRequestModel {
    gid?: string;
    invoiceBatchGid?: string | undefined;
    clientGid?: string;
    jobGid?: string;
    invoiceDate?: Date;
    amountExTax?: number;
    amountTax?: number;
    amountIncTax?: number;
    paid?: boolean;
    amountPaid?: number;
    lineItems?: UpdateInvoiceRequestLineItemModel[] | undefined;
}

export class UserCreateModel implements IUserCreateModel {
    /** Current User Email Address */
    emailAddress!: string;
    /** Current User Password */
    password!: string;
    /** Current User First Name */
    firstName!: string;
    /** Current User Last Name */
    lastName!: string;
    /** Current User Phone Number */
    phone!: string;
    /** Current User Mobile Number */
    mobile!: string;

    constructor(data?: IUserCreateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
        }
    }

    static fromJS(data: any): UserCreateModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserCreateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        return data;
    }
}

export interface IUserCreateModel {
    /** Current User Email Address */
    emailAddress: string;
    /** Current User Password */
    password: string;
    /** Current User First Name */
    firstName: string;
    /** Current User Last Name */
    lastName: string;
    /** Current User Phone Number */
    phone: string;
    /** Current User Mobile Number */
    mobile: string;
}

export class UserEmailModel implements IUserEmailModel {
    /** New Email Address */
    newEmailAddress!: string;

    constructor(data?: IUserEmailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newEmailAddress = _data["newEmailAddress"];
        }
    }

    static fromJS(data: any): UserEmailModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserEmailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newEmailAddress"] = this.newEmailAddress;
        return data;
    }
}

export interface IUserEmailModel {
    /** New Email Address */
    newEmailAddress: string;
}

export class UserModel implements IUserModel {
    gid?: string;
    name?: string | undefined;
    isDeleted?: boolean;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.name = _data["name"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["name"] = this.name;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IUserModel {
    gid?: string;
    name?: string | undefined;
    isDeleted?: boolean;
}

export class UserPasswordModel implements IUserPasswordModel {
    /** Current User Password */
    currentPassword!: string;
    /** New Password */
    newPassword!: string;

    constructor(data?: IUserPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): UserPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IUserPasswordModel {
    /** Current User Password */
    currentPassword: string;
    /** New Password */
    newPassword: string;
}

export class UserProfileModel implements IUserProfileModel {
    gid?: string;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    roles?: string[] | undefined;

    constructor(data?: IUserProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gid = _data["gid"];
            this.emailAddress = _data["emailAddress"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
        }
    }

    static fromJS(data: any): UserProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gid"] = this.gid;
        data["emailAddress"] = this.emailAddress;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUserProfileModel {
    gid?: string;
    emailAddress?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    roles?: string[] | undefined;
}

export class ValidationProblemDetails implements IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = (this.errors as any)[key];
            }
        }
        return data;
    }
}

export interface IValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;

    [key: string]: any;
}

export class Body implements IBody {
    file?: string;

    [key: string]: any;

    constructor(data?: IBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.file = _data["file"];
        }
    }

    static fromJS(data: any): Body {
        data = typeof data === 'object' ? data : {};
        let result = new Body();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["file"] = this.file;
        return data;
    }
}

export interface IBody {
    file?: string;

    [key: string]: any;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}